import { Injectable, EventEmitter } from '@angular/core';
import { Observable, from, BehaviorSubject, Subject, forkJoin, interval, Subscription } from 'rxjs';
import { mergeMap, map, tap, concatMap, delay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as platformClient from 'purecloud-platform-client-v2';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { RootScopeService } from './root-scope.service';
import { LogService } from './log.service';
import * as _ from 'lodash';
import * as Constants from '../models/Constants';
import { ALISConstants } from '../models/ALISConstants';
import { Router } from '@angular/router';
import { CustBusService } from './customer-search-bussiness-logic.service';
import { UserData, queues } from '../models/UserData';
import { Global } from '../global/globalApi';
import { NewAgentApiService } from './new-agent-api.service';
import { InteractionEventDTO } from '../models/InteractionEventDTO';
import { AwsSqsService } from './aws-sqs.service';
import { CallCustomerAttributes, InteractionDTO } from '../models/customer.model';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { MatDialog } from '@angular/material/dialog';
import { TimerService } from './timer.service';
import { isObject } from 'lodash';



/* Keys for LocalStorage**/
const LANGUAGE_KEY = 'gc_language';
const ENV_KEY = 'gc_environment';

@Injectable({
  providedIn: 'root',
})
export class GenesysCloudService {
  private client = platformClient.ApiClient.instance;
  private usersApi = new platformClient.UsersApi();
  public presenceApi = new platformClient.PresenceApi();
  private tokensApi = new platformClient.TokensApi();
  public conversationsApi = new platformClient.ConversationsApi();
  private queues: queues = new queues();
  public interactionModel: InteractionDTO = new InteractionDTO();
  public multipleChatTimerMap: any = {};
  public OrganizationApi= new platformClient.OrganizationApi();
  className = "GenesysCloudService";

  /* private notification = new platformClient.NotificationsApi(); **/

  /* Authorization values **/
  language: string = 'en-us';
  environment: string = '';
  accessToken = '';
  isAuthorized = new BehaviorSubject<boolean>(false);
  queueName: string = '';
  public intervalId: any;
  hasDuelDesktopIndicator: any;



  /*Cache for presence definitions**/
  presenceDefinitions = new BehaviorSubject<
    platformClient.Models.OrganizationPresence[]
  >([]);
  offlinePresenceId = '';
  genesysNotificationPresence = new Subject();
  domainNameResponse = new Subject();
  private _ALISConnected = new Subject<boolean>();
  public webSocketSubscription!: WebSocketSubject<unknown>;

  pageSize: number = 25;
  pageNumber: number = 1;
  totalPage: number = 1;
  liveInteractionInterval  // using to clear liveInteractionInterval
  /*Below Observable hold the value of Environment Login Url which is NEXT by
  the Cloud RegistrationCComponent of Dashboard page **/
  public _environment = new Subject<string>();

  /*Below Observable hold the value of ALIS presece Status (i.e On-Queue,Off-Queue,Offline)**/
  public _presenceStatus = new Subject<string>();

  //Interaction DTO
  public interactionEventDTO = new InteractionEventDTO();

  // Persist search values
  lastUserSearchValue = '';
  lastQueueSearchValue = '';
  agentQueues: Array<any> = new Array<any>();//to handle the how many queues agent having access
  // Redirect variable
  pinEntryAuthProcEmitter: EventEmitter<any> = new EventEmitter();
  alisLogin = ''; restoreLiveData: any;

  statusInfo: any;
  constructor(
    public rootScope: RootScopeService,
    public newAgentApiService: NewAgentApiService,
    public logService: LogService,
    private router: Router,
    public customerService: CustBusService,
    public awsSQSService: AwsSqsService,
    public encryptDecryptService: EncryptDecryptService,
    public dialog: MatDialog,
    public timerService: TimerService,

  ) {
    // Try to get saved language and environment information from localstorage
    this.language = localStorage.getItem(LANGUAGE_KEY) || this.language;
    this.environment = localStorage.getItem(ENV_KEY) || this.environment;
    /*Get the event login url value by subscribing the Observable**/
    this._environment.subscribe((res) => {
      this.environment = res;
    });
    this.updateGenAttribute();
  }
  /* istanbul ignore next */
  private loginImplicitGrant(): Observable<platformClient.AuthData> {
    let clientId: any = sessionStorage.getItem('ALIS_CLIENT_ID') ? sessionStorage.getItem('ALIS_CLIENT_ID') : environment.GENESYS_CLOUD_CLIENT_ID;

    console.log(this.rootScope.GENESYS_CLOUD_CLIENT_ID)
    return from(
      this.client.loginImplicitGrant(
        this.rootScope.GENESYS_CLOUD_CLIENT_ID || clientId,
        this.alisLogin
      )
    ).pipe(
      map((data) => {
        this.logService.debugLogs(data, this.className);
        this.accessToken = data.accessToken;
        this.isAuthorized.next(true);
        this.logService.infoLogs('User authorized.', this.className);
        return data;
      })
    );
  }

  /* istanbul ignore next */
  initialize(): Observable<any> {
    this.client.setPersistSettings(true);
    this.client.setEnvironment(this.environment);
    return this.loginImplicitGrant();
    /* Currently Below Code is not Useable, we have commented it may be used in future scenarios
    .pipe(
      mergeMap((data) => from(this.presenceApi.getPresencedefinitions())),
      tap((data) => {
        if (!data.entities) return;
        // Get the ID of the Offline Presence
        this.offlinePresenceId = data.entities.find(
          (p) => p.systemPresence === 'Offline'
        )!.id!;
        // Get the list for the other presences
        this.presenceDefinitions.next(
          data.entities.filter(
            (p) =>
              !(p.systemPresence === 'Offline' || p.systemPresence === 'Idle')
          )
        );
      })
    ); **/
  }

  /* istanbul ignore next */
  setLanguage(language: string | null): void {
    if (language) {
      /* istanbul ignore next */
      this.language = language;
      localStorage.setItem(LANGUAGE_KEY, this.language);
    }
  }

  /* istanbul ignore next */
  setEnvironment(environment: string | null): void {
    if (environment) {
      /* istanbul ignore next */
      this.environment = environment;
      localStorage.setItem(ENV_KEY, this.environment);
    }
  }

  /* istanbul ignore next */
  getUserMe(): Observable<platformClient.Models.UserMe> {
    return from(
      this.usersApi.getUsersMe({
        expand: ['routingStatus', 'presence'],
      })
    );
  }

  // setUserPresence(
  //   userId: string,
  //   presenceId: string
  // ): Observable<platformClient.Models.UserPresence> {
  //   return from(
  //     this.presenceApi.patchUserPresencesPurecloud(userId, {
  //       presenceDefinition: { id: presenceId },
  //     })
  //   );
  // }

  // logoutUser(userId: string): Observable<any> {
  //   return forkJoin({
  //     deletetoken: from(this.tokensApi.deleteToken(userId)),
  //     setOffline: from(
  //       this.presenceApi.patchUserPresence(userId, 'PURECLOUD', {
  //         presenceDefinition: { id: this.offlinePresenceId },
  //       })
  //     ),
  //   });
  // }

  /**
   * Logout users belonging to the queue. This includes agents that are not
   * 'on-queue'. For this sample app, we'd just take the first 100 members.
   * In order, to get ALL agents, paging of the results is needed.
   * @param queueId The Genesys Cloud Queue Id
   */

  /* istanbul ignore next */
  // genesys cloud notifications code
  genesysCloudNotificationSetup() {
    let userId = localStorage.getItem('userId');

    if (userId) {
      this.checkALISLastHeartBeat();
      this.getUserQueuesName(userId);
      //this.getOrganizationsMe();


      /**Resetting object to new instance of respective class in case of freshconnection/CCR1-11112 */
      this.genesysNotificationPresence = new Subject();
      this.conversationsApi = new platformClient.ConversationsApi();
      this.presenceApi = new platformClient.PresenceApi();
      this.usersApi = new platformClient.UsersApi();

      const client = platformClient.ApiClient.instance;
      const token = JSON.parse(localStorage.getItem('purecloud_auth_data')!);
      client.setAccessToken(token.accessToken);
      let apiInstance = new platformClient.NotificationsApi();
      // Create a new channel
      apiInstance
        .postNotificationsChannels()
        .then((data) => {
          const connURI = data.connectUri!;
          const channelId: string = data.id!;
          let body = [
            {
              id: `v2.users.${userId}.presence`,
            },
            {
              id: `v2.users.${userId}.conversations.calls`,
            },
            {
              id: `v2.users.${userId}.conversations.chats`,
            },
            {
              id: `v2.users.${userId}.conversations.callbacks`,
            },
            {
              id: `v2.users.${userId}.conversations.messages`
            }
          ];
          this.checkConnectionCall()
          // subscribe  new channel
          apiInstance
            .putNotificationsChannelSubscriptions(channelId, body)
            .then((data1) => {
              this.logService.debugLogs(
                `putNotificationsChannelSubscriptions success! data: ${JSON.stringify(
                  data1,
                  null,
                  2
                )}`, this.className
              );
            })
            .catch((err) => {
              if (err)
                this.logService.errorLogs("Error in putNotificationsChannelSubscriptions API Error = " + JSON.stringify(err), this.className);
            });
          // get notifications

          this.webSocketSubscription = webSocket(connURI);
          this.webSocketSubscription.subscribe({
            next: (msg: any) => {
              this.hasDuelDesktopIndicator = msg?.eventBody?.participants?.some(
                x => (x?.['purpose'] == 'customer' &&
                  (!x?.attributes?.[Constants.ALS_LP_ATB] ||
                    this.rootScope.duelDesk_indicator?.map(indicator => indicator.toLowerCase())?.includes(x?.attributes?.[Constants.ALS_LP_ATB]?.toLowerCase())))
              );

              this.rootScope.isGensysUDPErrorToHide = true;
              if (this.hasDuelDesktopIndicator) {
                this.logService.debugLogs("webSocketSubscription Msg = " + JSON.stringify(msg), this.className);
              }

              if(this.rootScope.unauthorizedConversations?.includes(msg?.eventBody?.id)){
                this.logService.debugLogs("webSocketSubscription = Unauthorized Conversation", this.className);
                return;
              }
              else if (msg.topicName != 'channel.metadata') {
                if (msg.topicName == `v2.users.${userId}.presence`) {
                  this.genesysNotificationPresence.next(msg);
                  this.setPresenceStatus(msg);
                }
                if (msg.topicName == `v2.users.${userId}.conversations.calls`) {
                  this.genesysNotifyCallOrChat(msg, Constants.conversion.call);
                  this.rootScope.genesysCallObj = msg;
                  //Set Interaction DTO
                  this.interactionEventDTO.alisConvId = msg?.eventBody?.id;
                  //Set Interaction DTO

                }
                if (msg.topicName == `v2.users.${userId}.conversations.chats`) {
                  // "CHAT_TO_CALL": "false"
                  this.genesysNotifyCallOrChat(msg, Constants.conversion.chat);
                  this.logService.debugLogs(msg, this.className);

                }
                if (msg.topicName == `v2.users.${userId}.conversations.messages`) {
                  // "CHAT_TO_CALL": "false"
                  this.genesysNotifyCallOrChat(msg, Constants.conversion.chat);
                  console.log(msg)

                }
                if (
                  msg.topicName == `v2.users.${userId}.conversations.callbacks`
                ) {
                  // this.rootScope.conversationId = msg?.eventBody?.id;
                  this.interactionEventDTO.alisConvId = msg?.eventBody?.id;
                  this.genesysNotifyCallOrChat(msg, Constants.conversion.callBack);
                }

              } else if (msg?.topicName == 'channel.metadata' && msg?.eventBody?.message == 'WebSocket Heartbeat') {
                this.rootScope.alisHeartBeatTimeStamp = new Date();
                if (this.hasDuelDesktopIndicator) {
                  this.logService.debugLogs("webSocketSubscription = WebSocket Heartbeat", this.className);
                }
              }

            }, // Called whenever there is a message from the server.
            error: (err) => {
              // Called if at any point WebSocket API signals some kind of error.
              // console.log(err + ' websocket error');
              this.rootScope.enableAlerts(
                Constants.ERROR,
                Constants.ALIS_CONNECTION_FAILURE_MSG
              );
              this._presenceStatus.next(
                Constants.ALIS_PRESENCE.ALISConnectionError
              );
              this.logService.errorLogs("Error in ALIS and CP connection = " + err, this.className)
              this.genesysCloudNotificationSetup();
              this.getPresenceStatus();

            },
            complete: () => {
              //  console.log('complete');
            }, // Called when connection is closed (for whatever reason).
          });
        })
        .catch((err) => {
          this.logService.errorLogs("Error in ALIS and CP connection = " + err, this.className)
          console.error(err);
        });
    }
  }
  /**
   * 
   * @param x  One of the object of participants array which hold LIVEUSER data.(a part of genesysObj)
   * @returns true/false when call transfer from CP to CS PRO
   * CCR3-8951
   */
  transferFlow(x) {
    return (x?.attribute?.[Constants.ALS_LP_ATB]?.include("CSPRO") && this.rootScope.isLiveCall && x?.endTime);
  }

  /**
   * Below method is triggered whenever  callback call notification
   * reaches to care portal application.
   * @param liveUser = One of the object of participants array which hold LIVEUSER data.(a part of genesysObj)
   * @param genesysObj = Full ALIS Object flowing from ALIS to Care portal app,where we will be getting all required data
   * @author : Pooja Gupta
   */

  genesysNotifyCallBack(liveUser, genesysObj) {
    /**handling the scenario when call gets diconnected aftr that callback notifcation coming as connected  */
    this.logService.debugLogs("Method genesysNotifyCallBack called , liveUser = " + liveUser + "\n GensysObj = " + genesysObj, this.className)
    if (this.rootScope.callBackCallDisconnected) {
      this.rootScope.callBackCallDisconnected = false;
      this.rootScope.isCallBackCall = false;
      return;
    }
    console.log('Method genesysNotifyCallBack called, liveUser =  ', liveUser?.state + 'genesysObj = ', genesysObj);
    if (
      !this.rootScope.isLiveCall &&
      liveUser?.state == ALISConstants.CONNECTED
    ) {
      /***  CallBack Calls received mode *****/
      let clientValue = genesysObj.filter(
        (x) =>
          x.attributes[ALISConstants.QUEUE_NAME] ||
          x.attributes[ALISConstants.PPTNAME] ||
          x.attributes[ALISConstants.PINV]
      )?.[0];
      // console.log('CalbackclientValue', clientValue);
      if (this.rootScope.checkBlankObj(clientValue[ALISConstants.ATTRIBUTES])) {
        this.rootScope.isCallBackCall = true;
      }
    } else if (liveUser?.state == ALISConstants.DISCONNECTED) {
      /***  Calls got disconnected *****/
      this.rootScope.isCallBackCall = false;
      // this.handleCallBackCallOnDisconnect();
      this.captureInteractionEventData(liveUser, this.rootScope.genesysCallObj);
    }
  }

  handleSpecificScenarioForCallbackEnd(currentCallConvId) {
    /**
     * Added below check for handling a specific scenario of callback call disconnect .
     * Scenario is : Since callback obj for connected & disconnected is same
     * and on disconnect callback and call object are reaching to care portal at same time
     * without any delay ,which thereby is leading  "isCallBackCall" this flag to
     * set true even in disconnect case ,
     * which might lead a problem in next incoming OR any kind of call flow landing to Care Portal.
     *
     */
    let tabObj = this.rootScope.customerTabs.find(function (each) {
      return each.id == 1;
    });
    if (tabObj?.activeCall == false) {
      this.rootScope.isCallBackCall = false;
    }
  }

  /**
  *@param genesysObj  participants events in genesys
  @param  callOrChat finding either chat or call*/
  genesysNotifyCallOrChat(entireGenesysObj, callOrChat?) {
    /** Below implementation for CCR1-3203 issue 1 */
    /** Commenting below method as it was not required , below implementation handle in the method genesysNotifyCallBack */
    // this.handleSpecificScenarioForCallbackEnd(entireGenesysObj?.id);

    this.logService.debugLogs("Method genesysNotifyCallOrChat called for " + callOrChat + "\n entireGenesysObj" + JSON.stringify(entireGenesysObj), this.className)

    let genesysObj = entireGenesysObj?.eventBody?.participants; let liveUser;
    this.rootScope.dialog.getDialogById('databaseSelector')?.close();
    //this.rootScope.conversationId = entireGenesysObj?.eventBody?.id;
    /* istanbul ignore next */
    if (this.rootScope.checkBlankObj(genesysObj)) {
      let recieveCount = genesysObj.filter(
        (data) =>
          data?.user?.id === localStorage.getItem('userId') &&
          data?.state != 'terminated'
      );
      // code for CCR1-4329
      let wrapupRequiredUser = genesysObj.find(
        (data) =>
          data?.purpose == 'customer' &&
          data?.state == 'terminated'
      );
      // code for CCR1-4329, updating isWrapupDone for call to remove hollow icon
      // no need to remove hollow icon after wrapup from genesys, commenting this code 
      // if (wrapupRequiredUser?.purpose == 'customer' && wrapupRequiredUser?.state == 'terminated' && callOrChat == Constants.conversion.call && !this.rootScope.isLiveCall) {
      //   this.rootScope.customerTabs.forEach((element) => {
      //     if (element.callDisconnected) {
      //       element.isWrapupDone = true;
      //     }
      //   });
      // }
      if (recieveCount?.length > 0) { liveUser = recieveCount[recieveCount.length - 1]; }
      if (callOrChat == Constants.conversion.call && this.hasDuelDesktopIndicator) this.genesysCall(liveUser, entireGenesysObj);
      else if (callOrChat == Constants.conversion.chat)
        this.genesysChat(liveUser, entireGenesysObj);
      else if (callOrChat == Constants.conversion.callBack && this.hasDuelDesktopIndicator)
        this.genesysNotifyCallBack(liveUser, genesysObj);
    }

    if (this.hasDuelDesktopIndicator) {
      if (genesysObj && sessionStorage.getItem('isLiveCall') == 'true') {
        this.rootScope.isLiveCall = true;

      } else if (sessionStorage.getItem('isLiveChat') == 'true') {
        this.rootScope.isLiveChat = true;
      }
    }
  }


  /**
 * pinEntryApp() - CCR3-6200- checking for PIN Entry connected & disconnected event
 * @author Amarjeet
 */
  pinEntryApp(genesysObj) {

    try {

      let pinEntryAppConn = genesysObj.find(
        (data) =>
          this.rootScope.PEAchannels?.includes(data?.name) &&
          data?.purpose == 'ivr' &&
          data?.state == 'connected' &&
          data?.direction == 'inbound'
      );

      let pinEntryAppDisconn = genesysObj.find(
        (data) =>
          this.rootScope.PEAchannels?.includes(data?.name) &&
          data?.purpose == 'ivr' &&
          data?.state == 'terminated' &&
          data?.direction == 'inbound'
      );
      if (pinEntryAppConn) { // it will exicute once VAL Entry app connected
        if (this.rootScope.activeCustTab.CS_SECURITY_LEVEL != Constants.securityLevels.SL4 && this.rootScope.activeCustTab.pinChangeApp.pinChangePrcActive == false) {
          this.rootScope.activeCustTab.pinEntryApp.step2Active = false;
          this.rootScope.activeCustTab.pinEntryApp.step2Complete = true;
          this.rootScope.activeCustTab.pinEntryApp.step3Active = true;
          this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PIN, "step2Completed Successfully");

        }
      }

      if (pinEntryAppDisconn) { // it will exicute once VAL Entry app disconnected
        let peaEndSecurityLevel = genesysObj.find(
          (data) =>
            data?.purpose == 'customer' &&
            data?.state == 'connected'
        );
        //calling Auth user API to update response after pin entry app disconnected
        if (this.rootScope.activeCustTab.pinEntryApp.step3Active && this.rootScope.activeCustTab.pinEntryApp.success == null) {
          if (peaEndSecurityLevel?.attributes?.["CS_PRSN_STAT"] != Constants.AuthMenu.FTU) {
            this.rootScope.peaAuthUserDetails.next(pinEntryAppDisconn);
            this.rootScope.setAuthattempt({ "authMethod": Constants.AuthCode.PIN, "result": "FAIL" });
          }
          this.updateTelephonyEventData(this.rootScope.genesysCallObj, peaEndSecurityLevel.attributes["CS_PRSN_STAT"], "disconnected");
        }

        if (this.rootScope.activeCustTab?.pinChangeApp?.pinChangePrcActive == false && this.rootScope.activeCustTab.pinEntryApp.success != "true" && peaEndSecurityLevel && peaEndSecurityLevel?.attributes?.PEA_END_SECURITY_LEVEL == Constants.PINV_ATTRIBUTES.FULLY_SECURED) {
          this.rootScope.activeCustTab.pinEntryApp.step3Complete = true;
          this.rootScope.activeCustTab.pinEntryApp.step3Active = false;
          this.rootScope.activeCustTab.pinEntryApp.success = 'true';
          // here will be logic to update security level & redirect on overview page
          if (peaEndSecurityLevel?.attributes?.["CS_PRSN_STAT"] == Constants.AuthMenu.FTU) {
            this.rootScope.activeCustTab.authenticationEgainContent.authenticationType = '';
            this.rootScope.activeCustTab.authenticationEgainContent.authenticationHtml = { name: "", content: "" };
            this.pinEntryAuthProcEmitter.emit(true);
          }
          else {
            this.pinEntryAuthProcEmitter.emit(false);
          }
          this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PIN, "step3Completed Successfully");
        }

        else {
          if (this.rootScope.activeCustTab.pinEntryApp.step3Active && peaEndSecurityLevel) {// it will exicute once pin entry app disconnected
            const pinChangeStatus = peaEndSecurityLevel.attributes?.PEA_FINAL_STATUS;
            if (pinChangeStatus) {
              this.statusInfo = this.parseStatusString(pinChangeStatus);
              console.log(this.statusInfo);
              if (this.statusInfo?.Status === 'FAIL') {
                if (peaEndSecurityLevel.attributes["CS_PRSN_STAT"] == Constants.AuthMenu.FTU) {
                  this.rootScope.activeCustTab.pinEntryApp.step3Complete = false;
                  this.rootScope.activeCustTab.pinEntryApp.step2Complete = true;
                  this.rootScope.activeCustTab.pinEntryApp.step1Complete = true;
                  this.rootScope.activeCustTab.pinEntryApp.step3Active = false;
                  this.rootScope.activeCustTab.pinEntryApp.step1Active = false;
                  this.rootScope.activeCustTab.pinEntryApp.step2Active = false;
                  // this.rootScope.activeCustTab.pinEntryApp.success = 'false';
                  
                  // CCR3-11548 Showing PIN Creation Error Message at the time of FTU 
                  this.rootScope.activeCustTab.pinEntryApp.pinError = this.getErrorMessage(this.parseStatusString(peaEndSecurityLevel?.attributes?.[Constants.SYSTEM_ERROR_MESSAGES.DEBUG_ERROR+this.statusInfo.Error_Code]),this.statusInfo,Constants.AuthMenu.FTU);
                   
                  this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.FTU, this.statusInfo?.Out_Come);

                } else {
                  this.rootScope.activeCustTab.pinEntryApp.step1Active = true;
                  this.rootScope.activeCustTab.pinEntryApp.step1Complete = false;
                  this.rootScope.activeCustTab.pinEntryApp.step2Active = false;
                  this.rootScope.activeCustTab.pinEntryApp.step2Complete = false;
                  this.rootScope.activeCustTab.pinEntryApp.step3Active = false;
                  this.rootScope.activeCustTab.pinEntryApp.step3Complete = false;
                  this.rootScope.activeCustTab.pinEntryApp.success = 'false';
                  this.rootScope.activeCustTab.authenticationEgainContent.authenticationType = '';
                  this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PIN, this.statusInfo?.Status);
                  this.rootScope.setAuthattempt({ "authMethod": Constants.AuthCode.PIN, "result": "FAIL" });
                }
              }
            }
          }
        }

      }
    } catch (error) {
      console.log(error)
    }

  }


  /**
 * pinEntryApp() - CCR3-6215- checking for PIN Change connected & disconnected event
 * @author Hashid
 */
  pinEntryChangeApp(genesysObj) {

    try {

      let pinEntryAppConn = genesysObj.find(
        (data) =>
          this.rootScope.PEAchannels?.includes(data?.name) &&
          data?.purpose == 'ivr' &&
          data?.state == 'connected' &&
          data?.direction == 'inbound'
      );

      let pinEntryAppDisconn = genesysObj.find(
        (data) =>
          this.rootScope.PEAchannels?.includes(data?.name) &&
          data?.purpose == 'ivr' &&
          data?.state == 'terminated' &&
          data?.direction == 'inbound'
      );


      if (pinEntryAppConn) { // it will exicute once PIN Entry app connected
        this.rootScope.activeCustTab.pinChangeApp.step2Active = false;
        this.rootScope.activeCustTab.pinChangeApp.step2Complete = true;
        this.rootScope.activeCustTab.pinChangeApp.step3Active = true;
        this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PINCNG, "step2Completed Successfully");
      }

      let peaEndSecurityLevel = genesysObj.find(
        (data) =>
          data?.purpose == 'customer' &&
          data?.state == 'connected'
      );

      if (pinEntryAppDisconn) { // it will exicute once PIN Entry app disconnected    
        if (this.rootScope.activeCustTab.pinChangeApp.step3Active && peaEndSecurityLevel && peaEndSecurityLevel?.attributes?.PEA_END_SECURITY_LEVEL == Constants.PINV_ATTRIBUTES.FULLY_SECURED) {// it will exicute once PIN change app disconnected
          const pinChangeStatus = peaEndSecurityLevel.attributes?.PEA_FINAL_STATUS;
          if (pinChangeStatus) {
            this.statusInfo = this.parseStatusString(pinChangeStatus);
            console.log(this.statusInfo);
            if (this.statusInfo?.Status === 'SUCCESS' && this.statusInfo?.Flow_OutCome === 'PIN_CREATION_SUCCESS') {
              this.rootScope.activeCustTab.pinChangeApp.pinChangeSucess = true;
              this.rootScope.activeCustTab.pinChangeApp.retryBtn = false;
              this.rootScope.activeCustTab.pinChangeApp.pinChngError = "";
              this.rootScope.activeCustTab.pinChangeApp.step3Complete = true;
              this.rootScope.activeCustTab.pinChangeApp.step2Complete = true;
              this.rootScope.activeCustTab.pinChangeApp.step1Complete = true;
              this.rootScope.peaAuthUserDetails.next(pinEntryAppDisconn);
              this.logService.infoLogs("PIN Change Step3 Completed Successfully", this.className);
              this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PINCNG, this.statusInfo?.Flow_OutCome);
            }
            else if (this.statusInfo?.Status === 'FAIL' && (this.statusInfo?.Out_Come === 'PIN_CREATION_USER_ERROR' || this.statusInfo?.Out_Come === 'PIN_CREATION_SYSTEM_ERROR' || this.statusInfo?.Out_Come === 'PIN_VALIDATION_USER_ERROR')) {
              this.rootScope.activeCustTab.pinChangeApp.step3Failed = true;
              this.rootScope.activeCustTab.pinChangeApp.step2Complete = true;
              this.rootScope.activeCustTab.pinChangeApp.step1Complete = true;
              this.rootScope.activeCustTab.pinChangeApp.step3Active = false;
              this.rootScope.activeCustTab.pinChangeApp.step1Active = false;
              this.rootScope.activeCustTab.pinChangeApp.step2Active = false;
              this.rootScope.activeCustTab.pinChangeApp.pinChangeSucess = false;
              this.rootScope.activeCustTab.pinChangeApp.retryBtn = true;
              // CCR3-11548 Showing PIN Change Error Message dynamically
              this.rootScope.activeCustTab.pinChangeApp.pinChngError = this.getErrorMessage(this.parseStatusString(peaEndSecurityLevel?.attributes?.[Constants.SYSTEM_ERROR_MESSAGES.DEBUG_ERROR+this.statusInfo.Error_Code]),this.statusInfo,Constants.AuthMenu.PINCNG);
              this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PINCNG, this.statusInfo?.Out_Come);

            }
            else if (this.statusInfo?.Status === 'SUCCESS' && this.statusInfo?.Flow_OutCome === 'PIN_VALIDATION_SUCCESS') {
              this.rootScope.activeCustTab.pinChangeApp.step3Failed = true;
              this.rootScope.activeCustTab.pinChangeApp.step2Complete = true;
              this.rootScope.activeCustTab.pinChangeApp.step1Complete = true;
              this.rootScope.activeCustTab.pinChangeApp.step3Active = false;
              this.rootScope.activeCustTab.pinChangeApp.step1Active = false;
              this.rootScope.activeCustTab.pinChangeApp.step2Active = false;
              this.rootScope.activeCustTab.pinChangeApp.pinChangeSucess = false;
              this.rootScope.activeCustTab.pinChangeApp.retryBtn = true;
              
              this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PINCNG, this.statusInfo?.Flow_OutCome);

            }
          }
        }
      }
    } catch (error) {
      console.log(error)
    }

  }

  /* istanbul ignore next */
  parseStatusString(statusString) {
    const statusObj = {};
    const keyValuePairs = statusString?.split(', ');
    keyValuePairs?.forEach(pair => {
      const [key, value] = pair.split(': ').map(item => item.trim());
      statusObj[key] = value;
    });
    return statusObj;
  }


  /*@param liveUser careportal login user 
  @param genesysObj Genesys notification in live call base  */
  genesysCall(liveUser, entireGenesysObj) {
    try {
      this.logService.debugLogs("Method genesysCall started ,liveUser \n=" + JSON.stringify(liveUser) + "\nentireGenesysObj = " + JSON.stringify(entireGenesysObj), this.className);
      this.rootScope.genesysNotificationCall.next(entireGenesysObj);
      let genesysObj = entireGenesysObj?.eventBody?.participants;

      let customerObj = genesysObj.filter((x) => x.purpose == 'customer');
      // console.log('Customer object: ' + JSON.stringify(customerObj));
      // let pinv;
      // let udpId;
      // if (customerObj != undefined) {
      //   pinv = customerObj[0]?.attributes?.PINV;
      //   udpId = customerObj[0]?.attributes?.CS_UDP_ID;
      //   if (udpId == undefined) {
      //     udpId = this.customerService.getDecryptedValue();
      //   }
      //   if (pinv == undefined) {
      //     let securityLevel = '0';
      //     if (customerObj[0]?.attributes?.SSS != undefined) {
      //       securityLevel = customerObj[0]?.attributes?.SSS;
      //     } else if (customerObj[0]?.attributes?.CS_SECURITY_LEVEL != undefined) {
      //       securityLevel = customerObj[0]?.attributes?.CS_SECURITY_LEVEL;
      //     }
      //     //console.log('securityLevel:' + securityLevel);
      //     pinv = this.getPINVFromSecurityLevel(securityLevel);
      //   }
      // }

      //console.log('Customer PINV: ' + pinv);
      //console.log('Cs Upd Id: ' + udpId);

      /* istanbul ignore next *///(x?.recording == true && x?.recordingState == 'active') ||
      this.logService.infoLogs("liveUser state = " + liveUser?.state, this.className)
      if (
        !this.rootScope.isLiveCall &&
        (this.dailingOutBoundEvent(liveUser, genesysObj) ||
          (liveUser?.state == 'connected' &&
          genesysObj.find(
            (x) => ((x?.['purpose'] == 'customer' &&
              x?.['state'] == 'connected'))
          )))
      ) {

        this.logService.infoLogs("Purpose customer and genesysObj state connected check passed", this.className)

        let clientvalue = genesysObj.filter(
          (x) =>
            (x?.['purpose'] == 'customer' &&
              (x?.['state'] == Constants.ALIS_Live_Status.connected ||
                (x?.['state'] == Constants.ALIS_Live_Status.dialing &&
                  x?.['direction'] == 'outbound'))) &&
            (x.attributes['QUEUE_NAME'] ||
              x.attributes['PPT-NAME'] ||
              x.attributes['PINV'])
        )?.[0];
        // console.log('Method genesysCall ', clientvalue);

        this.logService.debugLogs("ClientValue Object = " + JSON.stringify(clientvalue), this.className)
        this.identifyTransferredCall(entireGenesysObj);

        if (this.rootScope.checkBlankObj(clientvalue?.attributes)) {
          this.identifyInboundOrOutBoundCall(liveUser, clientvalue, entireGenesysObj.eventBody?.id);
        }/**
      @author Vamsi.pamidala
      To handle the alternative outbound flow and check the outbound call is initiated or not
      updateing the client id in genesys client attributes for preselect the client in customer search page    */
        else if (!this.rootScope.customerTabs.find(x => x.outboundCallInitiate)) {
          this.logService.infoLogs("ClientValue attributes blank case, Outbound call case", this.className)
          clientvalue = genesysObj[1];
          this.queueName = this.getQueueNameFromGenEvent(liveUser);

          if (this.queueName) {
            clientvalue.attributes = { QUEUE_NAME: this.queueName };
            this.identifyInboundOrOutBoundCall(liveUser, clientvalue, entireGenesysObj.eventBody?.id);
            try {
              this.updateParticipantAttributes(entireGenesysObj?.eventBody?.id, clientvalue.id, clientvalue);
            } catch (error) {
              console.log(error);
            }

          }

        }
        else {
          // console.log('Attributwes blank', clientvalue?.attributes);
          //localStorage.setItem('isLiveCall', 'false');
        }
      }
      else if (liveUser?.state == 'disconnected' || liveUser.endTime) {
        this.logService.infoLogs("Genesys Event :disconnected invoked", this.className)
        this.rootScope.liveCallDetails.next(null);
        this.afterCallDisconnect(liveUser, entireGenesysObj);
      }
      else if (this.rootScope.isLiveCall && (genesysObj.find((data) => this.rootScope.VALChannel?.includes(data?.name)))) {
        /**VAL FLow is initiated from CP if its true CCR1-8115 */
        if (this.rootScope.customerTabs.find(x => x.conversationId == entireGenesysObj.eventBody?.id && !x.additionalAccount)) {
          this.parseVALAppResponse(genesysObj, liveUser);
        }
      }
      else if (this.rootScope.isLiveCall) {
        if (this.rootScope.activeCustTab.pinChangeApp.pinChangePrcActive == false
          && this.rootScope.customerTabs.find(x => x.conversationId == entireGenesysObj.eventBody?.id && !x.additionalAccount && x.CS_SECURITY_LEVEL != "4")) {
          this.pinEntryApp(genesysObj);
        }
        else {
          this.pinEntryChangeApp(genesysObj);
        }
      }

    } catch (error) {
      console.log(error);
    }
  }

  /**
   * CCR1-8115
   * @param genesysObj 
   * @param liveUser 
   * @returns 
   */
  parseVALAppResponse(genesysObj, liveUser) {

    /** data  = { "name" = "ALIS ALV" } */

    let valEntryAppConn = genesysObj.find(
      (data) =>
        this.rootScope.VALChannel?.includes(data?.name) &&
        data?.purpose == 'ivr' &&
        data?.state == 'connected' &&
        data?.direction == 'inbound'
    );

    if (valEntryAppConn) {
      this.rootScope.activeCustTab.VALData.step2Complete = true;
      this.rootScope.activeCustTab.VALData.step3Active = true;
      this.rootScope.activeCustTab.VALData.displayStep3Content = true;
      this.rootScope.activeCustTab.VALData.displayStep2Content = false;
      this.rootScope.activeCustTab.VALData.step3Complete = false;
      /**Added for handling the scenario wherein CSR goes to transfer the call  to val*/
      this.rootScope.activeCustTab.VALData.valProcessActive = true; 
    }
    else{

    let valAppDisConnected = genesysObj.find(
      (data) =>
        this.rootScope.VALChannel?.includes(data?.name) &&
        data?.purpose == 'ivr' &&
        data?.state == 'terminated' &&
        data?.direction == 'inbound'
    );

    if (valAppDisConnected) {
      let valAtrrObj = genesysObj.find(
        (data) =>
          data?.purpose == 'customer' &&
          data?.state == 'connected'
      );

      let attributesArr = valAtrrObj?.attributes;
      let statusInfo: any = this.parseStatusString(attributesArr?.ALV_FINAL_STATUS);
      console.log("VAL Status Info == ", statusInfo);
      if(this.rootScope.activeCustTab.VALData.valProcessActive){
        if (statusInfo?.Status == 'SUCCESS') {
          /**  "ALV_FINAL_STATUS": "Status : SUCCESS, Flow_OutCome: LOCK_SUCCESSFULLY_REMOVED_BY_PPT", */
          this.rootScope.activeCustTab.VALData.step3Complete = true;
          this.rootScope.activeCustTab.VALData.step3Active = false;
          this.rootScope.activeCustTab.VALData.displayStep3Content = false;
          this.rootScope.activeCustTab.VALData.displayStep3ContentAfterResponseSuccess = true;
          this.rootScope.activeCustTab.VALData.successMsg = Constants.VAL_SUCCESS_MSG;
          this.rootScope.activeCustTab.VALData.valProcessActive = false;
          this.rootScope.isAlertAdded = true;
        }
        else if (statusInfo?.Status == 'FAIL') {
          /** "ALV_FINAL_STATUS": "Status : FAIL, Out_Come: MENU_CHOICE_COLLECTION_NI, Error_Code: 6" **/
          if(statusInfo?.Out_Come == 'MENU_CHOICE_COLLECTION_STAR_KEY_INVOKED'){
            /** Case where it has be treated as sucesss */
            this.rootScope.activeCustTab.VALData.displayStep3ContentAfterResponseSuccess = true;
            this.rootScope.activeCustTab.VALData.step3Complete = true;
            this.rootScope.activeCustTab.VALData.step3Active = false;
            this.rootScope.activeCustTab.VALData.displayStep3Content = false;
            this.rootScope.activeCustTab.VALData.successMsg = Constants.VAL_SUCCESS_MSG_START_KEY;
            this.rootScope.isAlertAdded = true;
          }
          else{
            this.rootScope.activeCustTab.VALData.step3Complete = true;
            this.rootScope.activeCustTab.VALData.step3Active = false;
            this.rootScope.activeCustTab.VALData.displayStep3Content = false;
            this.rootScope.activeCustTab.VALData.displayStep3ContentAfterResponseSuccess = false;
            this.rootScope.activeCustTab.VALData.step2Complete = true;  
            this.rootScope.activeCustTab.VALData.errMsg = statusInfo?.Out_Come;
            this.rootScope.isAlertAdded = true;
        }
        this.rootScope.activeCustTab.VALData.valProcessActive = false;
        }
      }
    }
    }
  }

  afterCallDisconnect(liveUser, entireGenesysObj) {
    if (this.rootScope.outBoundPopUp) {
      this.rootScope.outBoundPopUp = false;
      this.rootScope.dialog.closeAll();
    }
   if(this.rootScope.unauthorizedConversations.includes(entireGenesysObj?.eventBody?.id)){
    delete this.rootScope.unauthorizedConversations[entireGenesysObj?.eventBody?.id];
    }
    this.rootScope.isScreenpopAttributeEnabled = true;
    this.rootScope.isConference = false;
    this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.DISCONNECT);
    this.captureInteractionEventData(liveUser, entireGenesysObj);
    this.rootScope.conversationId = 'NA';
    this.rootScope.isLiveCall = false; this.rootScope.altOutboundCall = false;

    let customerSessionId = this.rootScope.activeCustTab?.customerSessionId;
    if (this.rootScope.activeCustTab?.additionalAccount) {
      customerSessionId = this.rootScope.activeCustTab?.tabData?.parentData?.customerSessionId
    }

    this.timerService.stopTimer(customerSessionId);
    this.clearLiveCallInterval();

    this.clearActionOnCallChatEnds();
    this.updateCustTabStatus(false, true);
    //Transfer call
    this.rootScope.istransferred = false;


    if (this.rootScope.isCallBackCall) {
      this.handleCallBackCallOnDisconnect();
    }
    else {
      this.handleDuplicateCSTabOnDisconnect(entireGenesysObj?.eventBody?.id);
    }

    //Interaction DTO
    sessionStorage.setItem('isLiveCall', 'false');
    localStorage.setItem('isLiveCall', 'false');
    // Updated for CCR3-721
    if (!this.rootScope.checkCallOrChat())
      this.rootScope.setTimeOutDetails({ 'watch': true, 'stop': false });
    this.rootScope.outboundCallConnectedSub.unsubscribe();
    this.rootScope.outboundCallDialingSub.unsubscribe();
  }
  // /**
  //  * alertnative outbound call 
  //  * without opening any account start outbound call in gensysy this method is handle to open outboundcall tab
  //  */
  // alternativeOutbound(liveUser) {

  //   return ();
  // }
  /* This method is needed to be executed for SL1 calls.
 * SL1 inbound call /Outbound call /Callback call 's disconnect.
 * for these 3 call , line no 527 will always return true.
 * @author :Pooja Gupta
 */

  handleDuplicateCSTabOnDisconnect(conversationId?) {

    let that = this;
    let conversationid = conversationId ? conversationId : this.rootScope.conversationId
    let duplicateCSTabObj = _.find(this.rootScope.customerTabs, function (each) {
      // return each.customerSessionId == '1';
      return each.id == '1' && each.conversationId == conversationid;
    }
    );

    if (duplicateCSTabObj) {
      duplicateCSTabObj.closeIcon = false;  /**will remove close icon on duplicate CS tab */
      duplicateCSTabObj.activeCall = false; /**will remove phone icon  on duplicate CS tab */
      duplicateCSTabObj.iconClass = 'red';
      this.rootScope.displayRedIcon = false;

      // code added to handale unidentified chat
      if (duplicateCSTabObj?.activeChat) {
        duplicateCSTabObj.activeChat = false;
        duplicateCSTabObj.isWrapupDone = true;
        duplicateCSTabObj.interactionDisconnected = true;
      }
    }
  }

  /**
   * Below method handles callback disconnect when CSR is
   * in duplicate customer search tab OR in Customer account tab.
   * @author :Pooja Gupta
   */
  handleCallBackCallOnDisconnect() {
    this.rootScope.isCallBackCall = false;
    this.rootScope.callBackCallDisconnected = true;
    this.handleDuplicateCSTabOnDisconnect();
  }

  clearActionOnCallChatEnds() {
    this.rootScope.callChatEnds.next(true);
    this.rootScope.clearCustomerSearchState();
  }

  clearCustomerSearchState() {
    this.rootScope.callChatReceived = true;
    this.rootScope.clearCustomerSearchState();
  }

  /* istanbul ignore next */
  launchCustomerAccountTab(clientValue) {
    // console.log('method launchCustomerAccountTab called ', clientValue);
    this.logService.debugLogs("Method launchCustomerAccountTab called ,clientValue = ", clientValue)

    this.navigateToCustTab(clientValue);
    this.rootScope.liveCallDetails.next({
      clientValue: clientValue,
      conversationId: this.rootScope.conversationId,
    });
    sessionStorage.setItem('isLiveCall', 'true');
    localStorage.setItem('isLiveCall', 'true');
    this.getLiveInteraction();
  }

  /**
   * Below method identifies call type -Inboubd/Outbound
   * @param callerObj
   * @returns
   * @author :Pooja Gupta
   */
  /* istanbul ignore next */
  identifyInboundOrOutBoundCall(liveUser, clientValue, conversationId) {
    this.logService.debugLogs("Method identifyInboundOrOutBoundCall called ,direction = " + liveUser['direction'] + "  conversationId = " + conversationId, this.className);
    this.rootScope.isLiveCall = true;
    // console.log('Method identifyInboundOrOutBoundCall called', liveUser);
    if (liveUser['direction'] == 'inbound') {
      this.rootScope.callType = Constants.INBOUND_CALL_TYPE;
    } else if (liveUser['direction'] == 'outbound') {
      this.rootScope.callType = Constants.OUTBOUND_CALL_TYPE;
    }
    this.queueName = clientValue.attributes?.QUEUE_NAME;//JSON.stringify({ QUEUE_NAME: clientValue.attributes?.QUEUE_NAME });
    this.logService.debugLogs("QueuName = " + this.queueName, this.className);
    this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.CONNECTED);
    this.rootScope.conversationId = conversationId;
    this.logService.debugLogs("event = CONNECTED-CAll; , ConversationId = " + conversationId, this.className);
    this.launchCustomerAccountTab(clientValue);
    this.timerService.startTimerAtCallLand(liveUser?.connectedTime || clientValue?.connectedTime);
  }

  /**
   * Below method checks whether CSR agent has access/authorized to receive the call
   * @param callerObj
   * @returns boolean
   * @author :Pooja Gupta
   */
  /* istanbul ignore next */
  validateAcessForIncomingCaller() {
    // console.log('liveClient', this.customerService.liveClient);
    let clientObj = _.find(
      this.customerService.clients,
      (each) => each.clientId == this.customerService.liveClient
    );
    // console.log('clientObj', clientObj);
    if (clientObj) {
      return true;
    }
    return false;
  }

  /**
    * @param liveUser careportal login user 
    * @param genesysObj Genesys notification in live call base  
    */
  genesysChat(liveUser, entireGenesysObj) {
    this.logService.infoLogs("Method GenesysChat called ,liveUser = " + JSON.stringify(liveUser) + " EntireGenesysObj = " + JSON.stringify(entireGenesysObj), this.className);

    if (this.rootScope.isCallBackCall) {
      this.rootScope.isCallBackCall = false;
    }

    let genesysObj = entireGenesysObj?.eventBody?.participants;
    /* istanbul ignore next */
    /* Below checkChatToCallAtt filter the Genesys Chat event and check the agent participant attributes contain
     * (CHAT_TO_CALL : false )key-value, liverUser doesn't contain the key:value in case of
     * transfferd chat as CHAT_TO_CALL attribute only came in agent participant who received the actual original chat.*/
    let checkChatToCallAtt = genesysObj.filter(
      (participant) =>
        participant?.attributes?.CHAT_TO_CALL == 'false' &&
        participant?.purpose == 'agent'
    );
    // console.log('checkChatToCallAtt  :' + JSON.stringify(checkChatToCallAtt));
    this.logService.debugLogs("Method GenesysChat called ,checkChatToCallAtt = " + JSON.stringify(checkChatToCallAtt), this.className);

    if (
      liveUser?.state == 'connected' &&
      genesysObj[0].state == 'connected' &&
      (liveUser?.attributes?.CHAT_TO_CALL == 'false' ||
        checkChatToCallAtt?.length > 0)
    ) {
      delay(500);

      let clientvalue = _.find(
        genesysObj,
        (each) =>
          each.state == 'connected' && each.attributes?.[Constants.ALS_chat.ClientID]
      );
      this.logService.debugLogs(" ClientValue for Chat , clientvalue = " + JSON.stringify(clientvalue), this.className)

      if (this.rootScope.checkBlankObj(clientvalue?.attributes)) {

        this.logService.infoLogs("chatConversation = " + this.rootScope.chatConversations + " Id = " + entireGenesysObj?.eventBody?.id, this.className)
        if (this.rootScope.chatConversations.has(entireGenesysObj?.eventBody?.id)) {
          return;
        } else {
          this.rootScope.chatConversations.set(entireGenesysObj?.eventBody?.id, clientvalue.id);
          /**Below If block condition check the connected chat in the ALIS is transferred chat or not.
           * If it is a transferred chat then it update the clientValue attributes with boolean var isChatTransferred
           * with true that will be use in createNewTabDTO() method of CustomerSearchBusinessLogicService.*/

          this.queueName = this.getQueueNameFromGenEvent(liveUser);

          this.logService.infoLogs("QueueName in case of chat =   " + this.queueName, this.className)

          this.rootScope.callType = Constants.INBOUND_CALL_TYPE;
          //this.updateTelephonyEventData(entireGenesysObj, Constants.logEvent.CONNECTED);
          if (this.isTranferredChat(entireGenesysObj)) {
            clientvalue.attributes.isChatTransferred = true;
            this.updateTelephonyEventData(entireGenesysObj, 'TRANSFER-CHAT-CONNECTED');
          }
          this.rootScope.isLiveChat = true;
          localStorage.setItem('isLiveChat', 'true');
          this.logService.infoLogs("Chat Connected: conversationId = " + entireGenesysObj?.eventBody?.id, this.className);
          //   this.timerService.startTimerAtCallLand()
          this.updateTelephonyEventData(entireGenesysObj, Constants.logEvent.CONNECTED + '-CHAT');
          this.navigateToCustTab(clientvalue);
          this.rootScope.conversationId = entireGenesysObj?.eventBody?.id;
          clientvalue.attributes['QUEUE_NAME'] = this.queueName;
          /*converstion id required to maintain interaction */
          this.rootScope.liveChatDetails.next({
            clientValue: clientvalue,
            conversationId: entireGenesysObj?.eventBody?.id,
            liveUser: liveUser
          });

          this.startCheckLiveChatStatusTimer(entireGenesysObj?.eventBody?.id, liveUser?.type == Constants.WEBMSG);

        }
      } else {
        this.rootScope.isLiveChat = false;
        sessionStorage.setItem('isLiveChat', 'true');
        localStorage.setItem('isLiveChat', 'false');
      }
    }
    else if (this.rootScope.isLiveChat && liveUser?.state == 'disconnected' && !liveUser?.wrapup) {
      this.afterChatDisconnect(liveUser, genesysObj, entireGenesysObj);
      this.logService.infoLogs("Chat disconnected: " + entireGenesysObj?.eventBody?.id, this.className);

    }
  }

  afterChatDisconnect(liveUser, genesysObj, entireGenesysObj) {
    if (this.rootScope.chatConversations.has(entireGenesysObj?.eventBody?.id)) {
      this.rootScope.chatConversations.delete(entireGenesysObj?.eventBody?.id);
      this.clearLiveChatIntervalTimer(entireGenesysObj?.eventBody?.id);
    }
      if (this.rootScope.unauthorizedConversations.includes(entireGenesysObj?.eventBody?.id)) {
      delete this.rootScope.unauthorizedConversations[entireGenesysObj?.eventBody?.id];
    }
  //Added for CCR3-11668 handle unauthenticated chat disconnect
    if(this.rootScope.isLiveChat&&this.rootScope.customerTabs.find(x => x.conversationId == entireGenesysObj?.eventBody?.id && !x.additionalAccount)){
    // code added for CCR1-998, start timer after chat ended
    //  this.captureInteractionEventData(liveUser, entireGenesysObj);
    this.customerService.updateIdle(
      this.customerService.getTabDetails(
        genesysObj[0].attributes[Constants.ALS_chat.PrsnId],
        entireGenesysObj?.eventBody?.id
      ),
      this.rootScope.CCTConfigs.TIME_THRESHOLD
    );
    this.updateCustTabStatus(
      false,
      false,
      true,
      null,
      genesysObj[0].attributes
    );
    this.captureInteractionEventData(liveUser, entireGenesysObj);
    sessionStorage.setItem('isLiveChat', 'false');
    localStorage.setItem('isLiveChat', 'false');
    this.updateTelephonyEventData(entireGenesysObj, Constants.logEvent.DISCONNECT + '-CHAT');
    //Please dont add any line of code here because multple chats also need to handle please where @isLiveChat variable is update there u can write
    // }
    this.handleDuplicateCSTabOnDisconnect(entireGenesysObj?.eventBody?.id);
  }
    else if (this.rootScope.chatConversations.size == 0) {
      this.updateCustTabStatus(
        false,
        false,
        true,
        null,
        genesysObj[0].attributes
      );
      sessionStorage.setItem('isLiveChat', 'false');
      localStorage.setItem('isLiveChat', 'false');
    }
  }

  navigateToCustTab(clientValue) {
    // if (clientValue?.direction != 'outbound') {
    //   // if (clientValue.ENC_CS_CUSTOMER_ID) {
    //   this.router.navigate(['/customer-search'], {
    //     skipLocationChange: true,
    //   });
    //   //  }
    // }
    //
    // this.dialog.closeAll();
    this.logService.infoLogs("Method navigateToCustTab called ", this.className)
    this.rootScope.handleTimeoutDuringLiveInteraction();
    this.rootScope.dialog.getDialogById('filterPopup')?.close();
    this.rootScope.activeLink = Constants.CUSTOMER_SEARCH;
    if (this.rootScope.checkMaxCustAccount(true))
      this.updateCustTabStatus(true);
    else if (this.rootScope.activeChatOrCall() > 0)
      this.updateCustTabStatus(false, false, false, false, false, true);

  }

  /**
   * @author:Pooja
   * @param conversationId 
   * Below method invokes a timer thread which will be continously monitoring
   * status of chat in genesys .Even for multile chats too
   * CCR1-3999
   */

  startCheckLiveChatStatusTimer(conversationId, WB) {
    this.multipleChatTimerMap[conversationId] = setInterval(() => {
      this.getLiveInteractionChatStatus(conversationId, WB).subscribe({
        next: (res) => {
          if (res) {
            this.analyseLiveChatStatusResp(res);
          }
        },
        error: (err) => {
          console.log(JSON.stringify(err));
        },
      });
    }, this.rootScope.alisConInterval);
  }

  /**
   * Below method analyses response of timer thread which keeps monitoring 
   * live chat status and according update respective chat tab in care portal.
   * @author:Pooja
   * CCR1-3999
   * @param res 
   */

  analyseLiveChatStatusResp(res) {
    console.log("Method analyseLiveChatStatusResp called", res)
    let liveChatTab: any = _.find(this.rootScope.customerTabs, {
      activeChat: true, conversationId: res.id,
      additionalAccount: false,
    })

    if (this.rootScope.isLiveChat) {
      res.participants.forEach(data => {
        if (data.purpose == 'agent' && data?.state == 'connected' && data?.user?.id == localStorage.getItem('userId')) {
          if (liveChatTab?.activeChat && liveChatTab?.conversationId == res.id) {
            console.log(liveChatTab.conversationId + " Chat Interaction in both Care portal & Genesys");
          }
        }
        if (data.purpose == 'agent' &&
          (data?.state == Constants.ALIS_Live_Status.disconnected || data.state == Constants.ALIS_Live_Status.terminated)
          && data?.user?.id == localStorage.getItem('userId')) {
          console.log(liveChatTab.conversationId + " Chat Interaction in Care portal only and ended in Genesys");
          this.afterChatDisconnect(data, res.participants, { eventBody: res })
        }
      })
    }

  }



  /**
   * @param active
   * Below method for update the froozen
   * @activeCall
   * @activeChat
   * @cls for handle the chat not completely disconnect chat
   * @attributes handle multiple chat connected/disconnected state
   * @Max_Account handle the multiple chats in careportal reach max Account 
   *  */
  updateCustTabStatus(active, activeCall?, activeChat?, cls?, attributes?, Max_Account?) {
    if (cls) {
      /* istanbul ignore next */
      if (
        this.rootScope.holdLiveDetails.length > 0 &&
        this.rootScope.holdLiveDetails.find(
          (x) => x.id == attributes?.[Constants.ALS_chat.PrsnId]
        )
      ) {
        let index = this.rootScope.holdLiveDetails.findIndex(
          (x) => x.id == attributes?.[Constants.ALS_chat.PrsnId]
        );
        this.rootScope.holdLiveDetails[index].iconClass = 'green';
        // this.rootScope.holdLiveDetails.splice(index, 1);
        // this.wrapUpChat(attributes);
        // if (
        //   this.rootScope.checkCallOrChat() && this.rootScope.activeChatOrCall() &&
        //   this.rootScope.holdLiveDetails.length == 0
        // )
        //   this.customerService.updateCustTabStatus(true);
      } else {
        this.rootScope.customerTabs.forEach((x) => {
          if (x.id == attributes?.[Constants.ALS_chat.PrsnId])
            x.iconClass = 'green';
        });
        if (this.rootScope.checkLiveChatAccount()) {
          this.rootScope.setTimeOutDetails({ 'watch': false, 'stop': true });
        }
      }
    } else {
      let activeChatCount = _.filter(this.rootScope.customerTabs, {
        activeChat: true,
        additionalAccount: false,
      }).length;

      if (
        this.rootScope.holdLiveDetails.length > 0 &&
        (activeCall || activeChat)
      ) {
        let index = this.rootScope.holdLiveDetails.findIndex(
          (x) => x.id == attributes?.[Constants.ALS_chat.PrsnId]
        );
        this.rootScope.holdLiveDetails?.splice(index, 1);
        // this.rootScope.holdLiveDetails.pop();
      }
      // Additional Account Must Close Before Primary Account for a Chat CCR6-814
      else if ((activeChatCount <= 0) || (Max_Account && !active && this.rootScope.isLiveChat)) {
        this.updateChatTabStatus(active, this.rootScope.isLiveChat);
      }

      if (activeChat) {
        this.wrapUpChat(attributes);
      }
    }

    if (activeCall) {
      /* istanbul ignore next */

      // code added for CCR1-998, start timer after call ended
      this.rootScope.customerTabs.forEach((element) => {

        if (element.activeCall) {
          this.customerService.updateIdle(
            element,
            this.rootScope.CCTConfigs.TIME_THRESHOLD
          );
          //Code added for CCR1-4329 to show hollow icon for call,
          if (!element.additionalAccount) {
            element.interactionDisconnected = true;
          }
          //Code added for CCR1-871 ,
          element.activeCall = false;
          //  element.authenticateStatus = Constants.Not_Applicable;//interaction update in server

        }
      });
    }
    // else if (activeChat) {
    //   _.filter(this.customerTabs, { activeChat: true, activeCall: false, additionalAccount: false }).forEach(element => {
    //     element.activeChat = false;
    //   });
    // }
    /*
    * For CCR3-721, the following code handles the timeout session.
    * If there is an ongoing live call or chat, the timeout details are set to stop.
    */
    if (this.rootScope.isLiveCall || this.rootScope.checkLiveChatAccount()) {
      this.rootScope.setTimeOutDetails({ 'watch': false, 'stop': true });
    }
  }

  wrapUpChat(attributes) {
    /* istanbul ignore next */
    this.rootScope.customerTabs.forEach((x) => {
      if (x.id == attributes?.[Constants.ALS_chat.PrsnId] && x.activeChat) {
        x.isWrapupDone = true;
        x.activeChat = false;
        x.interactionDisconnected = true;
        //  x.authenticateStatus = Constants.Not_Applicable;
        if (x.additionalAccountId)
          this.updateValueInArr(
            x.additionalAccountId,
            'activeChat',
            attributes[Constants.ALS_chat.PrsnId]
          );
        if (
          this.rootScope.liveChatCTS?.length >= 1 &&
          this.rootScope.customerTabs.filter(
            (x) =>
              x.activeChat &&
              !x.additionalAccount &&
              x.clientId == attributes?.[Constants.ALS_chat.ClientID]
          )?.length < 1
        )
          this.rootScope.liveChatCTS.splice(
            this.rootScope.liveChatCTS.findIndex(
              (x) => x.clientId == attributes?.[Constants.ALS_chat.ClientID]
            ),
            1
          );
        this.customerService.customerCmpt?.liveCallFn();
      }
    });

    setTimeout(() => {
      /* istanbul ignore next */
      this.rootScope.isLiveChat = this.rootScope.customerTabs.find(
        (x) => x.activeChat && !x.isWrapupDone && !x.additionalAccount
      )
        ? true
        : false;

      setTimeout(() => {
        if (!this.rootScope.isLiveChat) {
          this.rootScope.liveChatCTS = [];
          this.clearActionOnCallChatEnds();
          this.rootScope.multipleChatCaseForClearingState = false;
          this.rootScope.conversationId = 'NA';

          this.updateChatTabStatus(false, this.rootScope.isLiveChat);

        }
        if (!this.rootScope.checkCallOrChat()) {
          this.rootScope.setTimeOutDetails({ 'watch': true, 'stop': false });
        }
      }, 5);
    }, 50);
  }

  /*
  chat tab status will update CCR6-814 
  call realted tab and research tab will be converet to frozen and disable closeicon 
  chat live or disconnect chat related tabs can be close or accessiable   */

  updateChatTabStatus(active, activeChat?) {
    _.filter(this.rootScope.customerTabs, {
      active: active,
      activeChat: false,
      activeCall: false,
    }).forEach((element) => {
      if (activeChat && element.channel != Constants.conversion.chat)
        element.active = !active;
      else if (!activeChat) element.active = !active;
    });
  }

  updateValueInArr(id, value, parentId) {
    let index = _.findIndex(this.rootScope.customerTabs, {
      id: id,
      parentId: parentId,
      [value]: true,
    });
    if (this.rootScope.customerTabs[index])
      this.rootScope.customerTabs[index][value] = false;
  }

  sendMessage(requestToConnectALIS: boolean) {
    this._ALISConnected.next(requestToConnectALIS);
  }

  onMessage(): Observable<boolean> {
    return this._ALISConnected.asObservable();
  }

  /**Below method is called in genesysCloudNotificationSetup() method to listen the Websocket
   * presence event and set the value to _presenceStatus Observable*/
  setPresenceStatus(genesysObj) {
    if (
      genesysObj &&
      genesysObj?.eventBody?.presenceDefinition?.systemPresence
    ) {
      let presenceStatus =
        genesysObj?.eventBody?.presenceDefinition?.systemPresence;
      this._presenceStatus.next(presenceStatus);
      this.updateTelephonyEventData(this.rootScope.genesysCallObj, 'AGENT-STATUS: ' + presenceStatus);
    }
  }

  /**Below method delete the token of ALIS and after deleting the token
   * we can't make the API call to ALIS  of that current session*/
  logOutUser(endRegistration?: boolean): Observable<any> {
    if (!endRegistration) {
      this.updateTelephonyEventData(this.rootScope.genesysCallObj, 'AGENT-LOGOUT');
    } return forkJoin({
      deletetoken: from(this.tokensApi.deleteTokensMe()),
    });

  }

  /**Below method logout the user from ALIS by deleting the token,
   * unsubscribing the listening Websocket events of ALIS,logout the ALIS region's
   * Applicaton and redirecting to logoutRedirectURI.*/
  /* istanbul ignore next */
  logOutALIS(sessionExpiry?) {
    if (sessionStorage.getItem('connectToGenesys') == 'true') {


      this.unsubscribeALISNotifications();

      this.rootScope.ALISRegistrationCardSuccess = false;
      this.rootScope.ALISRegistrationSuccessChangeOrg = false;
      this.rootScope.ALISRegistrationCardError = false;
      this.rootScope.setIsGensysLoggedIn(false);
      // this.client.logout(environment.LOGOUT_REDIRECT_URI);
      if (!sessionExpiry) {
        this.logOutUser().subscribe((res) => {
          console.log(res);
        });
        this.client.logout(
          this.alisLogin.includes('http://localhost')
            ? `${this.alisLogin}/log-out`
            : `${this.alisLogin}log-out`
        );
      } else this.router.navigate(['/log-out']);
    } else {
      this.router.navigate(['/log-out']);
    }
  }

  /**Below method Unsubscribe to websocket events of ALIS which stop
   * to listen the websockets events*/
  unsubscribeALISNotifications() {

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    if (this.rootScope.GenesysPureCloud) {
      clearInterval(this.rootScope.GenesysPureCloud);
    }

    this.webSocketSubscription?.unsubscribe();
  }

  /**Below method update the attributes on a conversation participant in Genesys Cloud*/
  updateParticipantAttributes(
    conversationId,
    participantId,
    body
  ): Observable<any> {
    return from(
      this.conversationsApi.patchConversationParticipantAttributes(
        conversationId,
        participantId,
        body
      )
    );
  }

  // method to update genesys security level
  updateSecurityLevelInGEN(conversationId, participantId, body, updateData) {
    this.updateParticipantAttributes(conversationId, participantId, body)
      .subscribe({
        next: (res) => {
          if (res) {
            this.logService.debugLogs(res, this.className);
            this.rootScope.activeCustTab.CS_SECURITY_LEVEL = updateData['CS_SECURITY_LEVEL'];
            this.rootScope.activeCustTab.endSL = updateData['CS_SECURITY_LEVEL'];
            this.rootScope.activeCustTab.authenticateStatus = updateData['authenticateStatus'];
            this.rootScope.activeCustTab.iconClass = updateData['iconClass'];

            if (this.rootScope.activeCustTab.otcData.validateOtcSuccess == true) {
              this.rootScope.activeCustTab.genesysAttributes.CS_AUTH_CD = Constants.AuthCode.OTC;
            }
            else if (this.rootScope.activeCustTab.pinEntryApp.success == 'true') {
              this.rootScope.activeCustTab.genesysAttributes.CS_AUTH_CD = res?.["attributes"]?.CS_AUTH_CD == Constants.AuthMenu.FTU ? Constants.AuthMenu.FTU : Constants.AuthCode['PIN'];
            }
            else if (this.rootScope.activeCustTab.genesysAttributes.CP_APPROVED_EXCPTION_SECURED == true) {
              this.rootScope.activeCustTab.genesysAttributes.CS_AUTH_CD = Constants.AuthCode.APE;
              this.rootScope.activeCustTab.genesysAttributes.CP_APPROVED_EXCPTION_SECURED = updateData?.['CP_APPROVED_EXCPTION_SECURED'];
            }
            else if (this.rootScope.activeCustTab.genesysAttributes.CP_INDICATIVE_DATA_SECURED == true && this.rootScope.activeCustTab.pinEntryApp.success == null) {
              this.rootScope.activeCustTab.genesysAttributes.CS_AUTH_CD = Constants.AuthCode['IND-DATA'];
              this.rootScope.activeCustTab.genesysAttributes.CP_INDICATIVE_DATA_SECURED = updateData?.['CP_INDICATIVE_DATA_SECURED'];
            }



            if (updateData['domain']) {
              // method to update customer account API with updated SL
              this.customerService?.updateTabSL({
                'customerSessionId': this.rootScope?.activeCustTab?.customerSessionId,
                'cusTab': {
                  genesysAttributes: this.rootScope?.activeCustTab?.genesysAttributes,
                  approvedExceptionIH: this.rootScope?.activeCustTab.approvedExceptionIH,
                  CS_SECURITY_LEVEL: updateData['CS_SECURITY_LEVEL'], authenticateStatus: updateData['authenticateStatus'], iconClass: updateData['iconClass']
                }
              });

              //updateData['domain'].emit();
              this.customerService.goToCustOverView.next(true);
            }
            this.rootScope.setAuthattempt({ "authMethod": res?.["attributes"]?.CS_AUTH_CD, "result": "PASS" });
            this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.SUCCESS, res?.["attributes"]);
          }

          // console.log('patchConversationParticipantAttributes returned successfully.' + res);
        },
        error: (err) => {
          if (err) {
            this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.FAILURE, err);
            //  console.log('There was a failure calling patchConversationParticipantAttributes' + err);
            this.rootScope.indicatorClass = "red";
            this.rootScope.isGENSYSErrorToHide = false;
            this.updateGenesysClientConfig();
            this.rootScope.errorMsg = Constants.GENSYS_CONS[401] + Constants.AlertMsg.genesysError;//common error message required o show in Genesys api fail CCR3-2575 suggested  form @vinod
            this.logService.errorLogs(err, this.className);
          }
        },
      });
  }



  /**
   * Get queues for user
   *
   * @param {String} userId User ID
   * @param {Object} opts Optional parameters
   * @param {Number} opts.pageSize Page size (default to 25)
   * @param {Number} opts.pageNumber Page number (default to 1)
   * @param {Boolean} opts.joined Is joined to the queue (default to true)
   * @param {Array.<String>} opts.divisionId Division ID(s)
   */

  getUserQueuesName(userId) {
    let apiInstance = new platformClient.RoutingApi();
    apiInstance.getUserQueues(userId, {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      joined: true['joined'],
      divisionId: this.pageSize['divisionId'],
    })
      .then((data: any) => {
        if (data) {
          this.queues.queueNameList = data['entities'].map((p) => p.name);
          data.entities.forEach(element => {
            this.agentQueues.push(element)
          });

          // this.agentQueues.concat(data.entities);
          //console.log('queueResponse--->'+data);
          if (data['pageCount'] > this.pageNumber) {
            this.pageNumber = this.pageNumber + 1;
            this.getUserQueuesName(userId);

          }

        }
      })

      .catch((err) => {
        this.logService.errorLogs('There was a failure calling getUserQues', this.className);
        console.error(err);
      });
  }

  updateUserQueueService(data): Observable<any> {
    this.logService.infoLogs("Method updateUserQueueService API called  " + data, this.className);
    this.newAgentApiService
      .putApi(Global.UPDATE_USER_QUEUE, data, 'false', false)
      .subscribe((res) => {
        this.logService.infoLogs("Method updateUserQueueService API called ,Response =  " + res, this.className);
        if (res) {
          console.log('queueName response--->' + JSON.stringify(res));
        }
      });
    return this.domainNameResponse;
  }

  handleContinueButtonALISRegisterPopup() {
    //  console.log('hello i am continue');
    this.rootScope._ALISSelectedRegionObj.subscribe((res) => {
      sessionStorage.setItem('ALISRegisteredRegionObj', JSON.stringify(res));
    });
    this.sendMessage(true);
    sessionStorage.setItem('connectToGenesys', 'true');
  }
  /**
   * 
   * @param securityLevel 
   * @returns 
   */
  getPINVFromSecurityLevel(securityLevel: any) {
    let pinv = 'U';
    switch (securityLevel) {
      case '0':
      case '1':
      case '2':
        pinv = 'U';
        break;
      case '3':
        pinv = 'P';
        break;
      case '4':
        pinv = 'S';
    }
    return pinv;
  }
  //  CCR1-2842
  getSssFromSecurityLevel(securityLevel: any) {
    let tempSL = 'Unsecured';
    switch (securityLevel) {
      case '0':
      case '1':
      case '2':
        tempSL = 'Unsecured';
        break;
      case '3':
        tempSL = 'Partially Secured';
        break;
      case '4':
        tempSL = 'Fully Secured';
    }
    return tempSL;
  }
  /**
   * Below method value for isTransferredFlagg for buckets field of IH
   * which will be true for transferred or conference call
   * @author:Pooja - CCR1-4834
   */
  getValue(tabdt) {
    if (tabdt?.lastInteractionStatus?.includes('Transferred') || tabdt?.lastInteractionStatus?.includes('Conference')) {
      return true;
    }
    else {
      return false;
    }
  }

  captureInteractionEventData(liveUser, entireGenesysObj, restore?) {
    //Interaction DTO
    this.logService.debugLogs("Method captureInteractionEventData called on call disconnect , liveUser = " + liveUser + "entireGenesysObj = " + entireGenesysObj + "restore =" + restore, this.className)
    this.interactionModel = new InteractionDTO();
    try {


      if (!this.rootScope.isLiveCall && !this.rootScope.isLiveChat && !restore) {
        return;
      }
      console.log(
        'Staring to capture interaction data inside captureInteractionEvent ', liveUser
      );
      let genesysObj = entireGenesysObj?.eventBody?.participants;
      let customerObj = genesysObj?.filter((x) => x.purpose == 'customer');
      // console.log(
      //   'Customer object in capture Interaction data ' +
      //   JSON.stringify(customerObj[0])
      // );
      let udpId = customerObj[0]?.attributes?.UDP_GBL_ID;
      if (udpId == undefined) {
        udpId = this.customerService.getDecryptedValue();
      }

      let tabdt = this.rootScope.customerTabs.find(
        (x) => x.conversationId == entireGenesysObj?.eventBody?.id && !x.additionalAccount,
      );

      let res: any;

      if (tabdt) {
        tabdt.endSL = tabdt.authenticateStatus;
        tabdt.conversationDisconnectedTime = liveUser?.endTime;
        res = tabdt?.tabData?.tabData;
      }

      //console.log('Active tab in capture interaction' + JSON.stringify(tabdt));
      //console.log('Active tab in capture interaction res' + JSON.stringify(res));
      this.interactionModel.externalRefId = entireGenesysObj?.eventBody?.id; // Convid
      this.interactionModel.clientId = this.customerService.checkClientSystemMappingAndReplace(tabdt?.clientId);// tabdt?.clientId;
      if (this.interactionModel.clientId == null) {
       
        this.interactionModel.clientId = tabdt?.channel === Constants.conversion.chat ? this.customerService.getChatClientId(tabdt?.clientId) : this.customerService.getClientId();
        this.logService.errorLogs('There was a failure calling getClient From customer account:' + JSON.stringify(this.interactionModel.clientId), this.className);
      }
      this.interactionModel.created = liveUser?.endTime;
      this.interactionModel.begin = liveUser?.connectedTime ? liveUser?.connectedTime : liveUser?.endTime;
      this.interactionModel.end = liveUser?.endTime;
      this.interactionModel.system = 'careportal';
      //  CCR1-2842
      let sss, sse;

      if (customerObj != undefined) {
        let securityLevl = '0';
        if (customerObj[0]?.attributes?.SSS != undefined && customerObj[0]?.attributes?.SSE != undefined) {
          // securityLevl = customerObj[0]?.attributes?.SSS
          sss = this.getSssFromSecurityLevel(customerObj[0]?.attributes?.SSS);

          // securityLevl = customerObj[0]?.attributes?.SSE
          sse = this.getSssFromSecurityLevel(customerObj[0]?.attributes?.SSE);

        }
      }
      //let startingSecurityLevelObj = { 'keyName': 'startingSecurityLevel', 'keyValue': sss || tabdt?.startSL }
      //let endingSecurityLevelObj = { 'keyName': 'endingSecurityLevel', 'keyValue': sse || tabdt?.endSL }

      console.log("this.queueName", this.queueName)
      let queueName = 'NA';
      if (this.queueName && this.queueName != '') {
        queueName = this.queueName;
      }
      else {
        let queueNameFromServer = this.getQueueNameFromGenEvent(liveUser);
        if (queueNameFromServer)
          queueName = queueNameFromServer;
      }
      let queueNameObj = { 'keyName': Constants.QUEUE_NAME_KEY_BUCKET, 'keyValue': queueName }
      let isTransferedObj = { 'keyName': Constants.IS_TRANSFERRED_FLAG, 'keyValue': this.getValue(tabdt) }
   
      let arr: any = [];
      let isSecuredObj: any;
      let securityMethodObj: any;
      let securityMethod: any;
      let isSecured = 'No';
      // CCR3-10820
      let authChannel = '';
      let authChannelObj: any;

      if (tabdt?.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) {
        isSecured = 'Yes';
        // CCR3-10820 
          let Attributes =customerObj[0]?.attributes;
        if (tabdt?.authChannel) {

          let authMethodsParsed;
          try {
            authMethodsParsed = Attributes?.[Constants.ALIS_ATTRIBUTE_NAMES.CIM_DATA] ? JSON.parse(Attributes?.[Constants.ALIS_ATTRIBUTE_NAMES.CIM_DATA]) : undefined;
            if (authMethodsParsed && authMethodsParsed?.['authMethods']) {

              securityMethod = Constants.AuthMethods[authMethodsParsed?.['authMethods']];
              authChannel = Constants.AUTH_CHANNELS.IVR;

            }
            else {
              securityMethod = Constants.AuthMethods['IND-DATA'];
              authChannel = Constants.AUTH_CHANNELS.IVR;
            }
          } catch (error) {

            this.logService.errorLogs('Error parsing in authMethods: ' + Attributes[Constants.ALIS_ATTRIBUTE_NAMES.CIM_DATA]?.['authMethods'], this.className);
            securityMethod = '';
            authChannel = '';
          }

        }
        else if (customerObj[0]?.attributes?.CS_AUTH_CD) {
          securityMethod = Constants.AuthMethods[customerObj[0]?.attributes?.CS_AUTH_CD];
          authChannel = Constants.AUTH_CHANNELS.CP;
        }

        securityMethodObj = {
          'keyName': Constants.SECURITY_METHOD, 'keyValue': securityMethod
        }
        // CCR3-10820
        authChannelObj = {
          'keyName': Constants.AUTH_CHANNELS.authKeyName, 'keyValue': authChannel
        }
        arr.push(securityMethodObj);
        arr.push(authChannelObj);

      }
      if (this.rootScope.authAttempts.has(tabdt?.customerSessionId)) {
        // let authAttemptss = { 'keyName': Constants.AUTH_ATTEMPT, 'keyValue': this.rootScope.authAttempts.get(tabdt?.customerSessionId) };
        // arr.push(authAttemptss);
        this.logService.debugLogs(JSON.stringify(this.rootScope.authAttempts.get(tabdt?.customerSessionId)), this.className);
        this.rootScope.authAttempts.delete(tabdt?.customerSessionId);
      }
      isSecuredObj = { 'keyName': Constants.INTERACTION_STATUS_SECURED_KEY_BUCKET, 'keyValue': isSecured }
      // arr.push(startingSecurityLevelObj)
      //arr.push(endingSecurityLevelObj)
      arr.push(queueNameObj);
      arr.push(isTransferedObj);
      arr.push(isSecuredObj);
      this.interactionModel.buckets = arr;
      let custUpdtPayload = {

        'customerSessionId': tabdt?.customerSessionId,
        'cusTab': {
          'endTime': this.interactionModel?.end,
          'activeChat': false,
          'activeCall': false,
          'lastInteractionStatus': tabdt?.lastInteractionStatus,
          'interactionDisconnected': true,
          'isWrapupDone': tabdt?.isWrapupDone
        }
      }
      this.customerService.updateCustomerInElasticCache(custUpdtPayload);

      if (tabdt?.additionalAccountId) {
        let custUpdAddPayload = {
          'customerSessionId': this.rootScope.customerTabs.find((x) =>
          (x.parentId == tabdt?.id &&
            x.conversationId == tabdt?.conversationId))?.customerSessionId,
          'cusTab': {
            'activeChat': false,
            'activeCall': false,
            //  authenticateStatus: Constants.Not_Applicable,
            'lastInteractionStatus': tabdt.lastInteractionStatus
          }
        }
        this.customerService.updateCustomerInElasticCache(custUpdAddPayload);
      }
      // console.log(
      //   'Entire Genesys obj in capture interaction ' +
      //   JSON.stringify(entireGenesysObj)
      // );
      if (tabdt?.channel === Constants.conversion.call) {
        this.interactionModel.channel = Constants.conversion.call;
      } else if (tabdt?.channel === Constants.conversion.chat) {
        this.interactionModel.channel = Constants.conversion.chat;
      }
      if (
        customerObj[0]?.direction == 'inbound' ||
        tabdt?.channel == Constants.conversion.chat ||
        this.rootScope.isCallBackCall
      )
        this.interactionModel.initiated = 'External';
      else {
        this.interactionModel.initiated = 'Internal';
      }

      // delegate
      this.interactionModel.delegate = {
        name: this.rootScope.firstName + ' ' + this.rootScope.lastName,
        delegateId: this.rootScope?.lanId ? this.rootScope?.lanId : sessionStorage.getItem('lanId'),
        phoneNumber: 'N/A',
        emailAddress: this.rootScope.emailId,
        telephonyId : localStorage.getItem(Constants.TELEPHONY_ID) || this.rootScope.activeCustTab?.telephonyId
      };
      this.interactionModel.details = 'N/A';
      this.interactionModel.description = 'N/A';
      let activetabData = this.rootScope.customerTabs.find((x) => x.id == udpId);
      //console.log('Active call data in captureInteraction data ' + activetabData);

      if (tabdt?.id == 1) {
        this.setDefaultValuesSL1();
      }
      else {
        //subject
        // this.interactionModel.subject = {
        //   id: tabdt?.id,
        //   firstName: res?.firstName,
        //   lastName: res?.lastName,
        //   //type: tabdt?.defaultRole,
        // };

        this.interactionModel.contact = {
          id: tabdt?.id,
          name: tabdt?.title,
          type: tabdt?.customerType, // ? this.rootScope.customerTypeData.find(xx => xx?.fieldValue == parentDetails.customerType)?.fieldValueDescription : "NA",
          phoneNumber:
            tabdt?.channel == Constants.conversion.chat
              ? 'N/A'
              : tabdt?.tabData?.phoneNumber,
          emailAddress: 'N/A',
          ipAddress: 'N/A',
          role: tabdt?.defaultRole,
        };
      }
      if (tabdt?.approvedExceptionIH.size) {
        let APEXIH = { 'keyName': 'approved_Exceptions', 'keyValue': new Array<any>() };
        tabdt?.approvedExceptionIH?.forEach((values, keys) => {
          if (values) {
            APEXIH['keyValue'].push(values);
          }
        });

        this.interactionModel.buckets.push(APEXIH);
      }
      // console.log('tabdt?.conversationId ' + tabdt?.conversationId);
      this.rootScope.interactionsMap.set(tabdt?.conversationId, this.interactionModel);
      this.logService.debugLogs("Interaction Model Object = " + JSON.stringify(this.interactionModel), this.className);
      // console.log(
      //   'Interaction model captured on call disconnect ' +
      //   JSON.stringify(this.interactionModel)
      // );

      //Sending interaction details to SQS - commented out since CCR3-1911 pushing the interaction details on customer tab closure event
      // let interactionEventDTOClone = Object.assign({}, this.interactionModel);
      // this.awsSQSService.sendInteractionHistoryToSQS(interactionEventDTOClone);
    } catch (error) {
      this.logService.errorLogs("Error in creating IH =  " + error, this.className);
      console.log(error);
    }
  }




  /*Below method identify the Conference/Transfered call when the user is connected to the live call */
  identifyTransferredCall(entireGenesysObj) {
    this.logService.infoLogs("Method identifyTransferredCall called , entireGenesysObj = " + entireGenesysObj, this.className)
    let genesysObj = entireGenesysObj?.eventBody?.participants;
    let transferUserObj = genesysObj?.filter(
      (x) =>
        x.purpose == 'agent' &&
        (x.disconnectType == 'transfer' || x.consultParticipantId != undefined)
    );

    let callBackObj = genesysObj?.filter(
      (x) =>
        x.purpose == 'customer' &&
        (x?.attributes?.Callback_Channel != undefined)
    );
    console.log('Transfer agent obj ' + JSON.stringify(transferUserObj));

    this.logService.debugLogs("transferUserObj = " + JSON.stringify(transferUserObj), this.className)
    console.log("entireGenesysObj?.eventBody", entireGenesysObj?.eventBody)

    if (sessionStorage.getItem('isLiveCall') != 'true') {
      this.rootScope.isConference =
        entireGenesysObj?.eventBody.hasOwnProperty('maxParticipants');
      this.rootScope.istransferred = transferUserObj?.length > 0;
      this.rootScope.isCallBackCall =
        callBackObj?.length > 0;

    }
  }

  /**Below method identify the Transffered Chat when the user is connected to the Live Chat in ALIS */
  isTranferredChat(entireGenesysObj) {
    const transferUserObj = entireGenesysObj?.eventBody?.participants.filter(
      (participant) =>
        participant.purpose == 'agent' &&
        participant.disconnectType == 'transfer'

    );
    //console.log('Transfer agent obj ' + JSON.stringify(transferUserObj));
    return transferUserObj?.length > 0;
  }

  /* Update to N/A in case of SL1 calls*/
  setDefaultValuesSL1() {
    let defaultSubject = {
      id: 'N/A',
      firstName: 'N/A',
      lastName: 'N/A',
      type: 'N/A',
    };

    let defaultContact = {
      id: 'N/A',
      name: 'N/A',
      type: 'N/A',
      phoneNumber: 'N/A',
      emailAddress: 'N/A',
      ipAddress: 'N/A',
    };

    //this.interactionModel.subject = defaultSubject;
    this.interactionModel.contact = defaultContact;
  }

  /** Below method updates the attributes of a Genesys call participant based on the provided rowData.
   * It retrieves the live customer participant, encrypts the platformExternalId, 
   * and sends the updated attributes to the server.*/
  updateSL1CallAttributes(rowData, customerType) {
    this.logService.infoLogs("Method updateSL1CallAttributes ,  rowData = " + JSON.stringify(rowData) + " customerType = " + customerType, this.className);
    const genesysObj = this.rootScope.genesysCallObj;
    const liveCustomer = genesysObj?.eventBody?.participants?.find(
      (x) =>
        //  x?.recording === true &&
        //  x?.recordingState === 'active' &&
        x?.['purpose'] === 'customer' &&
        (x?.['state'] === Constants.ALIS_Live_Status.connected ||
          (x?.['state'] === Constants.ALIS_Live_Status.dialing &&
            x?.['direction'] == 'outbound'))
    );

    this.logService.infoLogs("Method updateSL1CallAttributes ,  liveCustomer = " + JSON.stringify(liveCustomer), this.className);

    if (!liveCustomer) {
      return; // No live customer found, exit 
    }
    const conversationId = genesysObj?.eventBody?.id;
    //check for Config_DesktopIndicator in genesysObj
    let hasDuelDesktopIndiCallAttributes = liveCustomer?.attributes?.[Constants.ALS_LP_ATB];


    const participantId = liveCustomer?.id;
    const encodedPlatformExternalId = this.encryptDecryptService.encodeAndEncrypt(rowData?.row?.platformExternalId);
    const body: CallCustomerAttributes = {
      attributes: {
        IS_CS_CUSTOMER_ID_ENCRYPTED: true,
        ENC_CS_CUSTOMER_ID: encodedPlatformExternalId,
        CS_CLIENT_ID: rowData?.row?.clientId,
        PINV: Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED,
        UDP_GBL_ID: rowData?.row?.udpId,
        CUSTOMER_TYPE: customerType,
        ROLE_TYPE: this.rootScope.activeCustTab?.defaultRole,
        QUEUE_NAME: this.getQueueNameFromGenEvent(liveCustomer)
      },
    };
    //@amarjeet added logic for CCR3-12547
    if (this.rootScope.identifyUserSubjectType(rowData?.row?.clientId) && this.rootScope.callType == Constants.OUTBOUND_CALL_TYPE) {
      delete body.attributes.UDP_GBL_ID
    }
    // Update the body attributes if 'duel_deskTopIndicator' is missing during transffer - CCR3-7924
    // if (!hasDuelDesktopIndiCallAttributes) {
    //   body.attributes = {
    //     ...body.attributes,
    //     Config_DesktopIndicator: Constants.DUEL_DESKTOP_INDICATOR_CARE_PORTAL,
    //   };
    // }

    this.updateParticipantAttributes(conversationId, participantId, body)
      .subscribe({
        next: (res) => {
          // console.log('patchConversationParticipantAttributes returned successfully.' + res);
          this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.SUCCESS, res?.["attributes"]);
        },
        error: (err) => {
          //  console.log('There was a failure calling patchConversationParticipantAttributes' + err);
          this.rootScope.indicatorClass = "red";
          this.rootScope.isGENSYSErrorToHide = false; this.updateGenesysClientConfig();
          this.rootScope.errorMsg = Constants.GENSYS_CONS[401] + Constants.AlertMsg.genesysError;//common error message required o show in Genesys api fail CCR3-2575 suggested  form @vinod
          this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.FAILURE, err);
        },
      });
  }
  /* @Vamsi Pamidala
  to get client/leftMenu/About card/interaction details data 
  when user restore application or ALIS login get all account details 
  call this function from api service
  
   */
  async getRestoreCompAccDetails(tab) {
    if (!tab.activeChat && !tab.activeCall && !tab.additionalAccount && !tab.idle) this.customerService.updateIdle(tab, this.rootScope.CCTConfigs.TIME_THRESHOLD_SUBSEQUENT)
    //   this.customerService.custAccService.openNewCustAcc(tab, true);
    //  await this.delay(11111); // Wait for 2 seconds before processing the next element
  }

  /* @Vamsi Pamidala
  Below Method to get genesys live call/chat/callback and open those account in careportal 
 when user manual login /mutlisession /browser crash /tab close   */
  getLiveInteractions() {
    let apiInstance = new platformClient.ConversationsApi();

    // Get active callback conversations for the logged in user
    apiInstance.getConversationsCallbacks()
      .then((data) => {
        if (data?.total && data.pageNumber && data.firstUri) {

          if (this.rootScope.restoreSession && data.entities?.find(x => x.participants?.some(x => x.callbackNumbers?.[0]))) {
            this.rootScope.isCallBackCall = true;
            this.customerInGenesys(data, Constants.conversion.call);
          }
          // console.log(`getConversationsCallbacks success! data: ${JSON.stringify(data, null, 2)}`);
        }
        // else if (this.rootScope.isLiveCall && this.rootScope.restoreSession) {
        //   this.updateCustTabStatus(false, true);
        //   this.rootScope.isLiveCall = false;
        // }


      })
      .catch((err) => {
        console.log("There was a failure calling getConversationsCallbacks");
        //console.error(err);
      });

    // Get active call conversations for the logged in user
    apiInstance.getConversationsCalls()
      .then((data) => {
        if (data?.total && !this.rootScope.isCallBackCall && data.firstUri) {
          this.customerInGenesys(data, Constants.conversion.call);

        } else if (this.rootScope.isLiveCall && !this.rootScope.isCallBackCall && this.rootScope.restoreSession) {
          this.updateCustTabStatus(false, true);
          this.rootScope.isLiveCall = false; this.rootScope.istransferred = false;
          this.rootScope.isConference = false;
        }


      })
      .catch((err) => {
        console.log("There was a failure calling getConversationsCalls");
        //console.error(err);
        this.rootScope.isGENSYSErrorToHide = false;
        this.rootScope.errorMsg = Constants.GENSYS_CONS[401] + Constants.AlertMsg.genesysError;
        this.rootScope.indicatorClass = 'red';
      });

    apiInstance.getConversationsChats()
      .then((data) => {
        if (data && data.total && data.firstUri) {
          data.entities = data.entities?.sort((a, b): any => {
            if (a?.participants?.length && b?.participants?.length && a.participants?.[0]?.connectedTime && b?.participants[0]?.connectedTime) {
              return new Date(a?.participants[0]?.connectedTime).valueOf() - new Date(b?.participants[0]?.connectedTime).valueOf();
            }
          });



          // console.log(data.entities.map(x => x?.participants?.[0].attributes?.['context.GlobalIdentifierId'] && x.participants[0].connectedTime));
          this.customerInGenesys(data, Constants.conversion.chat);
          // console.log(`getConversationsChats success! data: ${JSON.stringify(data, null, 2)}`);

        } else if (this.rootScope.isLiveChat && this.rootScope.restoreSession) {
          this.RestoreWrapUp();
          this.rootScope.isLiveChat = false;
        }


      })
      .catch((err) => {
        console.log("There was a failure calling getConversationsChats");
        //console.error(err);
      });

    apiInstance.getConversationsMessages()
      .then((data) => {
        if (data && data.total && data.firstUri) {
          data.entities = data.entities?.sort((a, b): any => {
            if (a?.participants?.length && b?.participants?.length && a.participants?.[0]?.connectedTime && b?.participants[0]?.connectedTime) {
              return new Date(a?.participants[0]?.connectedTime).valueOf() - new Date(b?.participants[0]?.connectedTime).valueOf();
            }
          });



          // console.log(data.entities.map(x => x?.participants?.[0].attributes?.['context.GlobalIdentifierId'] && x.participants[0].connectedTime));
          this.customerInGenesys(data, Constants.conversion.chat);
          // console.log(`getConversationsChats success! data: ${JSON.stringify(data, null, 2)}`);

        } else if (this.rootScope.isLiveChat && this.rootScope.restoreSession) {
          this.RestoreWrapUp();
          this.rootScope.isLiveChat = false;
        }


      })
      .catch((err) => {
        console.log("There was a failure calling getConversationsChats");
        //console.error(err);
      });

  }

  /** @VamsiKrishna
   * Common funcion is created  to handle live interacion deails base open single/mutltiple live account in careporal 
   *  when user click on alis resigter button and open account set delay to not to distrub other tabs  */
  async customerInGenesys(data: any, type: string) {
    if (!data.entities) {
      return; // No entities to process
    }
    for (const element of data.entities) {
      const customerParticipant = element?.participants?.find(x => x?.purpose === 'customer');
      if (customerParticipant) {
        this.hasDuelDesktopIndicator = !(customerParticipant.attributes?.[Constants.ALS_LP_ATB]) || this.rootScope.duelDesk_indicator?.map(indicator => indicator.toLowerCase())?.includes(customerParticipant?.attributes?.[Constants.ALS_LP_ATB]?.toLowerCase())
        if (this.rootScope.restoreSession && this.restoreLiveData?.length > 0 && this.restoreLiveData.find(x => x.conversationId == element.id)) {
          continue;
        }

        else {
          this.rootScope.genesysCallObj = { eventBody: element };
          this.genesysNotifyCallOrChat({ eventBody: element }, type);

          await this.delay(2000); // Wait for 2 seconds before processing the next element
        }
      }
    }
  }
  /**to maintain chat squence in careportal set a 2 sec delay to load customer account tab */
  async delay(ms: number) {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
  }

  /**@author VamsiKrishna
   * @customerParticipant update live Chat ClientID in customer search page client drop down  
   * restore application to maintain live chat client id 
   */
  updateliveChatClientID(customerParticipant) {
    if (!this.rootScope.liveChatCTS.find(
      (xx) => xx?.clientId == this.customerService.getClientId(customerParticipant.attributes[Constants.ALS_chat.ClientID])
    )) {
      this.rootScope.liveChatCTS.push(this.customerService.clients.find(x => x.clientId == this.customerService.getClientId(customerParticipant.attributes[Constants.ALS_chat.ClientID])));
    }
  }

  /**@author VamsiKrishna
   * @data live call/chat participants values
   * @type update based on liveCall/liveChat
   */
  updateRestoreAccount(data, type, tab) {

    const customerParticipant = data?.participants?.find(x => x?.purpose === 'customer');

    if (customerParticipant) {
      let activeUser = data?.participants?.filter(x => x?.user?.id === localStorage.getItem('userId'));
      let connectedUser = activeUser.find(x => x.state == Constants.ALIS_Live_Status.connected);

      let liveUser = connectedUser || activeUser[activeUser.length - 1];

      if (liveUser?.state == 'disconnected') {
        this.rootScope.setTimeOutDetails({ 'watch': true, 'stop': false });
        this.wrapUpChat(customerParticipant.attributes);
        if (tab.activecall || tab.activeChat) {
          this.updateCustTabStatus(
            false,
            false,
            true,
            null,
            customerParticipant.attributes
          );
          this.rootScope.setTimeOutDetails({ 'watch': true, 'stop': false });
        }
        this.captureInteractionEventData(customerParticipant, { eventBody: data }, true);
      }
      else {
        if (liveUser?.state != 'terminated') {
          this.customerService[type] = customerParticipant.attributes;

          if (type == 'liveCall') {
            this.rootScope.isLiveCall = true;
            this.rootScope.callType = (liveUser['direction'] == 'inbound' ?
              Constants.INBOUND_CALL_TYPE : Constants.OUTBOUND_CALL_TYPE);
            this.customerService.getClientId();
            if (tab?.lastInteractionStatus?.includes(Constants.isConference_CALL_TYPE) || tab?.lastInteractionStatus?.includes(Constants.Transferred_CALL_TYPE)) {
              this.rootScope.istransferred = tab.lastInteractionStatus?.includes(Constants.Transferred_CALL_TYPE);
              this.rootScope.isConference = tab.lastInteractionStatus?.includes(Constants.isConference_CALL_TYPE);
            } else if (!tab?.lastInteractionStatus) tab.lastInteractionStatus = this.rootScope.callType
            // this.identifyTransferredCall({ eventBody: data });

            this.timerService.startTimerAtCallLand(liveUser?.connectedTime);
            this.getLiveInteraction();
            this.updateCustTabStatus(true);
          }
          else {

            if (liveUser?.state == 'connected') {
              this.rootScope.isLiveChat = true;
              this.customerService.liveChat = customerParticipant.attributes;
              this.timerService.startTimerAtChatLand(tab?.customerSessionId, liveUser?.connectedTime);
              this.startCheckLiveChatStatusTimer(data?.id, liveUser?.type == Constants.WEBMSG);

              this.customerService.liveClient = this.customerService.getChatClientId(customerParticipant.attributes[Constants.ALS_chat.ClientID]); //customerParticipant?.attributes?.[Constants.ALS_chat.ClientID];
              this.updateliveChatClientID(customerParticipant);
              this.rootScope.chatConversations.set(data?.id, customerParticipant.id);
              this.updateChatTabStatus(true, this.rootScope.isLiveChat);
            }
            else {

              this.updateCustTabStatus(
                true,
                false,
                false,
                'green',
                customerParticipant.attributes
              );
            }

          }
          let customeraccount = this.rootScope.customerTabs.find(x => x.conversationId == data.id && !x.additionalAccount);

          this.rootScope.genesysCallObj = { eventBody: data };
          this.rootScope.conversationId = data.id;
          if (customeraccount) {
            this.rootScope.activeLink = Constants.CUSTOMER_SEARCH;
            this.rootScope.customerLink = customeraccount?.customerSessionId;
            // this.router.navigate(['/customer-search'], {
            //   skipLocationChange: true,
            // });
            this.customerService.updateActiveTabDetails(customeraccount?.customerSessionId);
            this.customerService.routeToActiveTab(
              customeraccount?.customerSessionId
            );

          }
        } else if (type == 'liveCall') {
          if (!this.rootScope.checkLiveCallAccount()) {


            this.rootScope.isLiveCall = false; this.rootScope.istransferred = false;
            this.rootScope.isConference = false;
            this.rootScope.callType = (liveUser['direction'] == 'inbound' ?
              Constants.INBOUND_CALL_TYPE : Constants.OUTBOUND_CALL_TYPE);
          }
          if (tab.activecall || tab.activeChat) { this.rootScope.setTimeOutDetails({ 'watch': true, 'stop': false }); this.updateCustTabStatus(false, true); }
          this.captureInteractionEventData(customerParticipant, { eventBody: data }, true);

        }
      }
    } else {
      this.captureInteractionEventData(customerParticipant, { eventBody: data }, true);

    }


  }

  /**
   * @author VamsiKrishna
   * @param conversationId to get live call details based on conversation id 
   * verifying the connection staus in restore the application 
   */
  checkConversationsCall(conversationId, tab) {
    this.conversationsApi.getConversationsCall(conversationId)
      .then((data) => {
        if (data) {
          this.updateRestoreAccount(data, "liveCall", tab);
        }
      }).catch((err) => {
        this.updateGenesysClientConfig();
        console.log("There was a failure calling getConversationsChats");
        //console.error(err);
      });
  }
  /**
  * @author VamsiKrishna
  * @param conversationId to get live chat details based on conversation id 
  * verifying the connection staus in restore the application 
  */
  checkConversationsChat(conversationId, tab) {
    this.conversationsApi.getConversationsChat(conversationId)
      .then((data) => {
        if (data) {
          this.updateRestoreAccount(data, "liveChat", tab);
        }
      }).catch((err) => {
        console.log("There was a failure calling getConversationsChats");
        this.updateGenesysClientConfig();
        //console.error(err);
      });
  }

  /**
 * @author VamsiKrishna
 * @param conversationId to get live chat details based on conversation id 
 * verifying the connection staus in restore the application 
 * CCR3-8241
 */
  getWebMessageData(conversationId, tab) {
    this.conversationsApi.getConversationsMessage(conversationId)
      .then((data) => {
        if (data) {
          this.updateRestoreAccount(data, "liveChat", tab);
        }
      }).catch((err) => {
        console.log("There was a failure calling getConversationsMessage");
        this.updateGenesysClientConfig();
        //console.error(err);
      });
  }


  /**
   * @author VamsiKrishna
   * @param conversationId to update[isWrapupDone,activeChat,authenticateStatus] attribute chat disconnect accounts 
   * 
   */

  RestoreWrapUp(conversationId?) {

    this.rootScope.customerTabs.forEach((x) => {
      if ((conversationId && x?.conversationId == conversationId || !conversationId) && x?.activeChat && !x?.additionalAccount) {
        x.isWrapupDone = true;
        x.activeChat = false;
        //  x.authenticateStatus = Constants.Not_Applicable;
      }
    });
  }

  /**CCR1-4246
      * @author Amarjeet
      * getLiveInteractionCallStatus() method using to check live call Interaction in genesys
      */
  getLiveInteractionCallStatus(): Observable<any> {


    let conversationId: any = _.find(this.rootScope.customerTabs, {
      activeCall: true,
      additionalAccount: false,
    })?.conversationId;
    if (!conversationId) clearInterval(this.liveInteractionInterval);

    return from(
      this.conversationsApi.getConversationsCall(conversationId)
    );
  }

  /**CCR1-4246
    * @author Amarjeet
    * getLiveInteractionChatStatus() method using to check live chat Interaction in genesys
    */
  getLiveInteractionChatStatus(conversationId, WB): Observable<any> {

    return from(
      WB ?
        this.conversationsApi.getConversationsMessage(conversationId) :
        this.conversationsApi.getConversationsChat(conversationId)
    );
  }

  /**CCR1-4246
    * @author Amarjeet
    * getLiveInteraction() method using to check live Interaction in genesys
    */
  getLiveInteraction() {
    this.liveInteractionInterval = setInterval(() => {
      this.getLiveInteractionCallStatus().subscribe({
        next: (res) => {
          if (res) {
            this.checkLiveCallStatus(res);
          }
        },
        error: (err) => {
          console.log(JSON.stringify(err));
          this.logService.errorLogs("Error in LiveIteractioncallstatus API hit" + err, this.className)
          this.updateGenesysClientConfig();
        },
      });
    }, this.rootScope.alisConInterval);
  }


  /**CCR1-4246
    * @author Amarjeet
    * checkLiveCallStatus() method using to check line interaction in both Care portal & genesys
    */
  checkLiveCallStatus(res) {
    let liveCallTab: any = _.find(this.rootScope.customerTabs, {
      activeCall: true,
      additionalAccount: false,
    })

    if (this.rootScope.isLiveCall && res?.participants?.length > 0) {

      let activeUser = res?.participants?.filter(x => x?.user?.id === localStorage.getItem('userId'));
      let activeCalls = activeUser.find(x => x.state == Constants.ALIS_Live_Status.connected && !x.endTime);
      let liveUser = activeCalls || activeUser[activeUser.length - 1];

      if (liveUser?.state == Constants.ALIS_Live_Status.connected) {
        if (liveCallTab.activeCall && liveCallTab.conversationId == res.id) {
          console.log(liveCallTab.conversationId + " call interaction in both Care portal & genesys");
        } else if (liveUser.state == Constants.ALIS_Live_Status.disconnected) {
          console.log(liveCallTab.conversationId + " call interaction in Care portal only");
          this.clearLiveCallInterval()
          this.rootScope.genesysCallObj = { eventBody: res };
          this.afterCallDisconnect(liveUser, { eventBody: res });
        }

      }
      else if (liveUser.state == Constants.ALIS_Live_Status.disconnected
        || liveUser.state == Constants.ALIS_Live_Status.terminated || liveUser.endTime) {
        console.log(liveCallTab.conversationId + " call interaction in Care portal only");
        this.logService.infoLogs("Genesys Event : " + liveUser.state, this.className)
        this.clearLiveCallInterval()
        this.rootScope.genesysCallObj = { eventBody: res };
        this.afterCallDisconnect(liveUser, { eventBody: res })
      }

    }

  }

  /**
   * Below method cleare the timer thread for respective chat for which
   * status is now disconnected .
   * Its mapped with conversationId and careportal supports mutiple chats so map is used .
   * @author:Pooja / CCR1-3999
   * @param conversationId 
   */
  clearLiveChatIntervalTimer(conversationId) {
    console.log("Method clearLiveChatIntervalTimer called for ", conversationId + "this.multipleChatTimerMap[conversationId] = ", this.multipleChatTimerMap[conversationId])
    if (this.multipleChatTimerMap[conversationId])
      clearInterval(this.multipleChatTimerMap[conversationId]);
  }


  /**CCR1-4246
  * @author Amarjeet
  * clearLiveCallInterval() stoping to check live interaction after call or chat ended. 
  */
  clearLiveCallInterval() {
    if (this.liveInteractionInterval)
      clearInterval(this.liveInteractionInterval);
  }

  updateTelephonyEventData(entireGenesysObj, telePhonyEvent, updateddata?) {

    if (telePhonyEvent === 'AGENT-STATUS: Unavailable' || telePhonyEvent === 'AGENT-STATUS: OFFLINE') {
      console.log(
        'Telephone event : ' +
        JSON.stringify(telePhonyEvent)
      );
      let livelogObj = this.rootScope.createAngluarLogsObject(telePhonyEvent, "telephony", null);
      this.awsSQSService.sendAngularLogsToSQS(livelogObj);
      return;
    }
    if (!this.rootScope.isLiveCall && !this.rootScope.isLiveChat) {
      return;
    }

    let genesysObj = entireGenesysObj?.eventBody?.participants;
    let customerObj = genesysObj?.filter((x) => x.purpose == 'customer');
    let udpId = "";
    let tabdt = this.rootScope.customerTabs.find(
      (x) => x.conversationId == entireGenesysObj?.eventBody?.id,
    );
    let res: any, conversationId: any = this.rootScope.conversationId;

    if (tabdt) {
      tabdt.endSL = tabdt.authenticateStatus
      console.log('endSL---->' + tabdt.endSL);
      console.log('startSL---->' + tabdt.startSL);
      res = tabdt?.tabData?.tabData;
      conversationId = tabdt.conversationId;
      udpId = tabdt.id;
    }

    let sss, sse;
    if (customerObj) {
      if (customerObj[0]?.attributes?.SSS && customerObj[0]?.attributes?.SSE) {
        sss = this.getSssFromSecurityLevel(customerObj[0]?.attributes?.SSS);

        if (sss === undefined) {
          sss = tabdt?.startSL;
        }
        sse = this.getSssFromSecurityLevel(customerObj[0]?.attributes?.SSE);
        if (sse === undefined) {
          sse = tabdt?.endSL;
        }
        if (!udpId) {
          if (customerObj[0]?.attributes?.IS_CS_CUSTOMER_ID_ENCRYPTED) {
            udpId = this.encryptDecryptService.decodeAndDecrypt(
              customerObj[0]?.attributes?.ENC_CS_CUSTOMER_ID
            );
          } else udpId = customerObj[0]?.attributes?.ENC_CS_CUSTOMER_ID;
        }
      }
      else if (customerObj[0]?.attributes?.PINV && telePhonyEvent == Constants.logEvent.CONNECTED) {
        sss = customerObj[0]?.attributes?.PINV == "U" ? Constants.UNSECURED : Constants.FULLY_SECURED;
        sse = sss;
      }
      else if (!customerObj[0]?.attributes?.PINV && telePhonyEvent == Constants.logEvent.CONNECTED && tabdt?.startSL == Constants.Not_Applicable) {
        sss = Constants.UNSECURED; sse = Constants.UNSECURED;
      }
      else if (telePhonyEvent.includes('CHAT')) {
        sse = Constants.FULLY_SECURED; sss = Constants.FULLY_SECURED;
        if (udpId == "") {
          udpId = customerObj[0]?.attributes?.[Constants.ALS_chat.PrsnId]
        }
      }
      else {
        sss = tabdt ? tabdt.startSL : Constants.UNSECURED; sse = tabdt ? tabdt.authenticateStatus : Constants.UNSECURED;
      }
    } else {
      sss = Constants.UNSECURED; sse = Constants.UNSECURED;
    }
    conversationId = (conversationId != 'NA' && conversationId ? conversationId : entireGenesysObj?.eventBody?.id);
    let eventMessages: string; let telePhonyMessage: string = "";

    if (this.rootScope.liveInteractionLogs.has(conversationId)) {
      telePhonyMessage = this.rootScope.liveInteractionLogs.get(conversationId);
      telePhonyMessage += "||";
    }

    if (Constants.AuthCode[telePhonyEvent]) {
      eventMessages = 'event:' + "ConversationId :" + conversationId + "|" + Constants.AuthMethods[telePhonyEvent] + ":" + updateddata;
      return this.logService.debugLogs(eventMessages, this.className);
    }
    else if (updateddata) {
      eventMessages = 'event: ' + telePhonyEvent;
      Object.keys(updateddata).forEach(x => {
        if (x)
          eventMessages += "|" + x + ":" + updateddata[x];
      })

    }
    else {
      eventMessages = 'event: ' + telePhonyEvent + '|date:' + new Date().toISOString() + '| conversationId: ' + (conversationId) + '| startingSecurityLevel: ' + sss + ' | endingSecurityLevel: ' + sse + ' | callerType: ' + this.rootScope.callType + ' | queueName: ' + this.queueName + '| CS_CUSTOMER_ID: ' + udpId;
    }
    this.logService.debugLogs(eventMessages, this.className);
    telePhonyMessage += eventMessages;
    console.log(telePhonyMessage);
    this.rootScope.liveInteractionLogs.set(conversationId, telePhonyMessage);
  }
  /**
   * @author VamsiKrishna
   * Genesys 
   */
  checkConnectionCall() {
    if (this.rootScope.isGenesysLoggedIn) {
      let userId = localStorage.getItem('userId') || "";
      this.rootScope.GenesysPureCloud = setInterval(() => {
        this.presenceApi.getUserPresencesPurecloud(userId).then((res) => {

          if (res) {
            console.info(res);
          }
        }).catch((err) => {
          console.log("There was a failure calling purecloud Api");
        });

      }, this.rootScope.CCTConfigs.GENSYS_IDLE_TIME * 1000);
    }
  }

  getQueueNameFromGenEvent(liveUser) {

    this.logService.infoLogs("Method getQueueNameFromGenEvent called ,agentQueues length = " + this.agentQueues?.length + " liveUser.queue.id = " + liveUser.queue.id, this.className);
    if (!this.agentQueues?.length) {
      // Get details about this queue.    // @Vamsi Pamidala Changes
      let apiInstance = new platformClient.RoutingApi();
      apiInstance.getRoutingQueue(liveUser.queue.id)
        .then((data) => {
          this.logService.debugLogs("Response in getRoutingQueue API hit " + JSON.stringify(data), this.className)
          return data.name;


        })
        .catch((err) => {
          console.log("There was a failure calling getRoutingQueue");
          this.logService.errorLogs("Error in getRoutingQueue API hit " + err, this.className)
        });

    }
    else {
      return this.agentQueues.filter(x => x.id == liveUser.queue.id)[0]?.name;
    }
  }

  /* Below method returns True if the live user is dialing outbound and
   there is a corresponding outbound event in the genesysObj array, otherwise false.*/
  dailingOutBoundEvent(liveUser, genesysObj) {
    this.logService.infoLogs("Method dailingOutBoundEvent called", this.className);
    return (liveUser?.state == Constants.ALIS_Live_Status.dialing && !this.rootScope.isCallBackCall &&
      genesysObj.find(
        (x) => ((x?.['purpose'] == 'customer' &&
          x?.['state'] == Constants.ALIS_Live_Status.dialing && x?.['direction'] == 'outbound'))))
  }

  //update genesys attribute via using subscribetion
  updateGenAttribute() {
    try {


      this.rootScope.patchGENAttribute.subscribe({
        next: (res) => {
          if (res) {
            this.updateParticipantAttributes(res.conversationId, res.participantId, res.body);
            let eventMessages = 'event:' + "ConversationId :" + res.conversationId;
            if (isObject(res.body))
              Object.keys(res.body).forEach(x => {
                if (x)
                  eventMessages += "|" + x + ":" + res.body[x];
              })
            else eventMessages = eventMessages += "|" + res.body;
            this.logService.debugLogs(eventMessages, this.className);

          }
        },
        error: (err) => {
          console.log("There was a failure calling getConversationsChats");
          console.error(err);

        }

      })
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Method is used to save all queues details from genesys which user has access
   */
  saveAllQueueFromGen() {
    if (this.rootScope?.agentQueues?.length == 0) {
      let apiInstance = new platformClient.RoutingApi();
      apiInstance.getRoutingQueuesMe()
        .then((data) => {
          data?.entities?.forEach(entity => {
            let queueObj = {
              id: entity?.id,
              name: entity?.name
            }
            this.rootScope.agentQueues.push(queueObj);
          })

        })
        .catch((err) => {
          console.log("Error while retrieving queues from genesys");
        });
    }
  }


  // handleCsProTransferCall(entireGenesysObj) {
  //   let genesysObj = entireGenesysObj?.eventBody?.participants;
  //   let customerObj = genesysObj?.filter(
  //     (x) =>
  //       x.purpose == 'customer'
  //   );
  //   let cusAttributes = customerObj?.[0]?.attributes;
  //   let convId = entireGenesysObj?.eventBody?.id;
  //   let participantId = customerObj?.[0]?.id;
  //   let body: CallCustomerAttributes = {
  //     attributes: {
  //       CP_INDICATIVE_DATA_SECURED: true,
  //       CS_AUTH_CD: Constants.AuthCode['IND-DATA']
  //     },
  //   };

  //   if (cusAttributes?.CS_SECURITY_LEVEL == '3' && cusAttributes?.CS_AUTH_METH?.includes(Constants.AuthMenu.UAS) && cusAttributes?.CP_INDICATIVE_DATA_SECURED != false) {
  //     this.updateParticipantAttributes(convId, participantId, body).subscribe({
  //       next: (res) => {
  //         // console.log('patchConversationParticipantAttributes returned successfully.' + res);
  //         this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.SUCCESS, res?.["attributes"]);
  //       },
  //       error: (err) => {
  //         //  console.log('There was a failure calling patchConversationParticipantAttributes' + err);
  //         this.rootScope.indicatorClass = "red";
  //         this.rootScope.isGENSYSErrorToHide = false;
  //         this.rootScope.errorMsg = Constants.GENSYS_CONS[401] + Constants.AlertMsg.genesysError;//common error message required o show in Genesys api fail CCR3-2575 suggested  form @vinod
  //         this.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.FAILURE, err);
  //       },
  //     });
  //   }

  // }
  updateGenesysClientConfig() {
    const client = platformClient.ApiClient.instance;
    const token = JSON.parse(localStorage.getItem('purecloud_auth_data')!);
    client.setAccessToken(token?.accessToken);
    client.setPersistSettings(true);
    client.setEnvironment(this.environment);
    this.conversationsApi = new platformClient.ConversationsApi();
  }
  /**
   * 
   */
  public syncLivestatus(type) {
    this.conversationsApi = new platformClient.ConversationsApi();
    let isWEBmessage = this.rootScope.activeCustTab.webMessage;
    let conversationId = this.rootScope.activeCustTab.conversationId;
    // Calls block
    if (type == Constants.conversion.call) {
      this.conversationsApi.getConversationsCall(conversationId)
        .then((data) => {
          if (data) {
            this.checkLiveCallStatus(data);
          }
        }).catch((err) => {
          console.log("There was a failure calling getConversationsCall");
          console.error(err);
          this.rootScope.activeCustTab.wrapUpData.callStatus = Constants.API_FAILURE_MSG;
        });
    }
    //Chats block
    else if (type == Constants.conversion.chat) {

      (isWEBmessage ?
        this.conversationsApi.getConversationsMessage(conversationId) :
        this.conversationsApi.getConversationsChat(conversationId))
        .then((data) => {
          if (data) {
            this.analyseLiveChatStatusResp(data);
          }
        }).catch((err) => {
          console.log("There was a failure calling getConversationsChats");
          console.error(err);
          this.rootScope.activeCustTab.wrapUpData.callStatus = Constants.API_FAILURE_MSG;
        });
    }
  }

  /**
   *  @sultan - CCR5-1010
   * This method is invoked within the genesysCloudNotificationSetup() to monitor the ALIS websocket connection.
   *  It sets up an interval to check the last heartbeat timestamp every 60 seconds, ensuring the websocket connection remains active.
   */
  checkALISLastHeartBeat() {
    this.intervalId = setInterval(() => this.alisLastHeartBeatDifference(), 60000);

  }

  /**
  * @sultan - CCR5-1010
  * This method checks the difference between the current timestamp and the last recorded ALIS heartbeat timestamp.
  * If the difference exceeds 60 seconds (60000 milliseconds), it triggers an error alert indicating a failure in the 
  * ALIS and Care Portal connection. 
  */
 /*istanbul ignore next */
  alisLastHeartBeatDifference(): void{

    const currentTimeStamp = new Date()?.getTime();
    const lastAlisHeartBeatTimeStamp = this.rootScope.alisHeartBeatTimeStamp?.getTime();

    if (lastAlisHeartBeatTimeStamp) {
      const differenceInMilliseconds = currentTimeStamp - lastAlisHeartBeatTimeStamp;
      if (differenceInMilliseconds > 60000) {

        this.rootScope.enableAlerts(
          Constants.ERROR,
          Constants.ALIS_CONNECTION_FAILURE_MSG
        );
        this._presenceStatus.next(
          Constants.ALIS_PRESENCE.ALISConnectionError
        );
        this.logService.errorLogs("Error in ALIS and CP connection =  NOT RECEIVED WEBSOCKET HEARTBEAT", this.className);

        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        this.genesysCloudNotificationSetup();
        this.getPresenceStatus();

      }

    }

  }

  /** Below method get the Presence Status of ALIS */
  getPresenceStatus() {
    this.getUserMe().subscribe({
      next: (res) => {
        let presence: any = res?.presence?.presenceDefinition?.systemPresence;
        this._presenceStatus.next(presence);
      },
      error: (error) => { },
    });
  }

  /**CCR3-7635
    * @author Amarjeet
    * getLiveCallStatusForAuthMethod() method using to check live call attributes from genesys to verify FTU current scenario
    */
  getLiveCallStatusForAuthMethod() {
    this.rootScope.increAlisRefreshCounter('REFRESH_AUTH_COUNT');                 // Called for increment refresh count on user refresh action-CCR3-6969
    this.getLiveInteractionCallStatus().subscribe({
      next: (res) => {
        if (res && res?.participants) {
          this.pinEntryApp(res?.participants);
        }
      },
      error: (err) => {
        console.log(JSON.stringify(err));
        this.logService.errorLogs("Error in Live call status for FTU API" + err, this.className)
        this.updateGenesysClientConfig();
      },
    });
  }

  /**CCR3-7941
    * @author vamsi
    * getLiveInteractionCallStatus() method using to check live call Interaction in genesys
    */
  getMessageInteractionStatus(conversationId) {
    this.conversationsApi.getConversationsMessage(conversationId).then((res) => {
      if (res?.["participants"]) {
        res?.["participants"]?.forEach(data => {
          if (data.purpose == 'agent' && data?.state == 'connected' && data?.user?.id == localStorage.getItem('userId')) {

            console.log(conversationId + " Chat Interaction in both Care portal & Genesys");

          }
          if (data.purpose == 'agent' &&
            (data?.state == Constants.ALIS_Live_Status.disconnected || data.state == Constants.ALIS_Live_Status.terminated)
            && data?.user?.id == localStorage.getItem('userId')) {
            console.log(conversationId + " Chat Interaction in Care portal only and ended in Genesys");
            this.afterChatDisconnect(data, res.participants, { eventBody: res })
          }
        })
      }

    })
      .catch((err) => {
        console.log("There was a failure calling getConversationsMessage");
        //console.error(err);
      });
  }


  /**
   * Retrieves the configuration for the desktop indicator by checking the live interaction call status.
   * If a live customer interaction is found, it updates the `Config_DesktopIndicator` property of the active customer tab.
   * In case of an error, logs the error and updates the Genesys client configuration.
   *CCR3-9296
   * @returns {void}
   */
  getConfigDesktopIndicator() {
    this.getLiveInteractionCallStatus().subscribe({
      next: (res) => {
        if (res) {
          let liveCustomer = res?.participants?.find(
            (x) =>
              x?.['purpose'] == 'customer' &&
              x?.['state'] == 'connected'
          );

          this.rootScope.activeCustTab.Config_DesktopIndicator= liveCustomer?.attributes?.[Constants.ALS_LP_ATB]||Constants.CARE_PORTAL;
        }
      },
      error: (err) => {
        console.log(JSON.stringify(err));
        this.logService.errorLogs("Error in LiveIteractioncallstatus API hit" + err, this.className)
        this.updateGenesysClientConfig();
      },
    });
  }

  /**
   * Fetches the current organization's details using the `getOrganizationsMe` API.
   * 
   * - Sets the `organizationName` property in the root scope with the organization's name.
   * - Displays an environment dialog based on the organization's name and lifecycle:
   *   - If the organization's name does not include "Dev" and the application is in production lifecycle, 
   *     it opens a dialog with a production environment message.
   *   - If the organization's name includes "Alight" and the application is not in production lifecycle, 
   *     it opens a dialog with a test environment message.
   * 
   * Handles errors by logging them using the `logService`.
   * 
   * @returns {void}
   * CCR3-10534
   */
  getOrganizationsMe() {
    try {


      this.OrganizationApi.getOrganizationsMe().then((res) => {
        if (res?.name) {

          this.logService.debugLogs("Response in getOrganizationsMe API hit " + JSON.stringify(res), this.className);

          switch (true) {
            case this.rootScope.alisOrganizations.find(x => x?.fieldValueDescription == Constants.ALIS_ORG_NAMES.TEST)?.fieldValue?.toLowerCase() == res.name?.toLowerCase() && this.rootScope.Prod_lifeCycle:
              this.rootScope.organizationName = Constants.ORG_NAME.DEV;
              this.rootScope.openEnvironmentDialog(Constants.PROD_ENV_MSG, Constants.PROD_ENV_MSG_SUB);
              break;

            case this.rootScope.alisOrganizations.find(x => x?.fieldValueDescription == Constants.ALIS_ORG_NAMES.PROD)?.fieldValue?.toLowerCase() == res.name?.toLowerCase() && !this.rootScope.Prod_lifeCycle:
              this.rootScope.organizationName = Constants.ORG_NAME.PROD;
              this.rootScope.openEnvironmentDialog(Constants.TEST_ENV_MSG, Constants.TEST_ENV_MSG_SUB);
              break;

            case this.rootScope.alisOrganizations.find(x => x?.fieldValueDescription == Constants.ALIS_ORG_NAMES.PROD)?.fieldValue?.toLowerCase() == res.name?.toLowerCase():
              this.rootScope.organizationName = Constants.ORG_NAME.PROD;
              break;

            default:
              this.rootScope.organizationName = Constants.ORG_NAME.DEV;
              break;
          }
        }

      }).catch((err) => {
        this.logService.errorLogs("Error in getOrganizationsMe API hit" + JSON.stringify(err), this.className)
      }
      );
    } catch (error) {
      this.logService.errorLogs("Error in getOrganizationsMe API hit" + error, this.className);

    }
  }

// CCR3-11548 Method to show error message on the basis of statusInfo and authtype
getErrorMessage(debugCode,statusInfo,authtype?) {
   
    let errorMsg = "";
    console.log("debugCode", debugCode);
   
     
      // Check for user error codes
    if (statusInfo?.Out_Come === 'PIN_CREATION_USER_ERROR' || statusInfo?.Out_Come === 'PIN_VALIDATION_USER_ERROR') {
      

        errorMsg= authtype=='FTU'? Constants.PIN_CREATION_ERROR['PIN_CREATION_USER_ERROR']:Constants.PIN_CREATION_ERROR['PIN_CHANGE_USER_ERROR'];
    }
    
    // Check for system error codes
    if (statusInfo?.Out_Come === 'PIN_CREATION_SYSTEM_ERROR' || statusInfo?.Out_Come==='PIN_VALIDATION_SYSTEM_ERROR' ) {
       
        // Return the appropriate error message based on authtype
          errorMsg= authtype=='FTU'? Constants.PIN_CREATION_ERROR['PIN_CREATION_SYSTEM_ERROR']: Constants.PIN_CREATION_ERROR['PIN_CHANGE_SYSTEM_ERROR'];
        
    
  }
   
   if(debugCode?.Error_Message && debugCode?.Error_Message?.trim().length > 0) {
        errorMsg = errorMsg +' '+ debugCode.Error_Message;
    }

    return errorMsg;
}


  /**
   * @author Sultan Khan
   * Fetches and processes conversation summaries for a given conversation ID.
   *
   * This method updates the UI state to indicate the fetching process, handles API responses,
   * and updates wrap-up data based on the summary results. It checks for specific error types
   * such as 'ConversationTooShort' and 'ConversationTooLong', and appends the agent's summary
   * to the comments if available. Handles API errors and updates relevant error flags.
   *
   * @param conversationId - The unique identifier of the conversation to fetch summaries for.
   */
  getSummaries(conversationId: string): void {
    this.conversationsApi.getConversationSummaries(conversationId)
      .then((data: any) => {

        if (data?.sessionSummaries?.length) {
          const userId = localStorage?.getItem?.('userId') || '';

          const agentSummary = data?.sessionSummaries?.find?.(summary =>
            summary?.participants?.find(participant => participant?.id == userId)
          );

          if (agentSummary) {
            this.logService.debugLogs("getConversationSummaries data " + JSON.stringify(agentSummary), this.className);

            if (agentSummary?.errorType == Constants.GENESYS_SUMMARY_ERROR_TYPES.CONVERSATION_TOO_SHORT) {
              this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryTooShort = true;

            } else {

              if (this.rootScope.activeCustTab.wrapUpData.comments) {
                this.rootScope.activeCustTab.wrapUpData.comments += '\n\n' + this.rootScope.formatAgentSummaryWrapUp(agentSummary);
              } else {
                this.rootScope.activeCustTab.wrapUpData.comments = this.rootScope.formatAgentSummaryWrapUp(agentSummary);
              }

            }
          } else {
            this.logService.debugLogs(
              `No agent participant found in sessionSummaries for conversationId: ${conversationId}. Data: ${JSON.stringify(data)}`,
              this.className
            );

            this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryApiForbidden = true;
          }

        }

        this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryFetching = false;
      })
      .catch((err: any) => {
        switch (err?.status) {
          case 403:
            this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryApiNoPermission = true;
            break;
          case 404:
            this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryApiForbidden = true;
            break;
          default:
            this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryApiError = true;
        }
        this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryFetching = false;
        this.logService.errorLogs("Error in getConversationSummaries: " + JSON.stringify(err), this.className);
      });
  }

}

